import { proxyCustomElement, HTMLElement as HTMLElement$1, createEvent, h, Host } from '@stencil/core/internal/client';
import { c as createCommonjsModule, a as commonjsGlobal, g as getDefaultExportFromCjs, b as isObjectLike_1, _ as _baseGetTag, d as _baseUnary, e as _nodeUtil, i as isEqual_1 } from './menuListConfig.js';
import { F as FOCUS_TYPE } from './common.js';
import { b as isEventTargetContained, m as autoFocusElement, j as transformToVersionedTag } from './utils.js';
import { b as DEFAULT_SHOW_STYLES, S as STATIC_SIDES, R as ROTATION_VALUES, c as ARROW_VERTICAL_OFFSET, d as ARROW_HORIZONTAL_OFFSET, e as DEFAULT_OFFSET, Z as Z_INDEX } from './consts.js';
import { d as defineCustomElement$k } from './wpp-action-button2.js';
import { d as defineCustomElement$j } from './wpp-checkbox2.js';
import { d as defineCustomElement$i } from './wpp-icon-calendar2.js';
import { d as defineCustomElement$h } from './wpp-icon-chevron2.js';
import { d as defineCustomElement$g } from './wpp-icon-cross2.js';
import { d as defineCustomElement$f } from './wpp-icon-dash2.js';
import { d as defineCustomElement$e } from './wpp-icon-error2.js';
import { d as defineCustomElement$d } from './wpp-icon-info2.js';
import { d as defineCustomElement$c } from './wpp-icon-success2.js';
import { d as defineCustomElement$b } from './wpp-icon-tick2.js';
import { d as defineCustomElement$a } from './wpp-icon-warning2.js';
import { d as defineCustomElement$9 } from './wpp-inline-message2.js';
import { d as defineCustomElement$8 } from './wpp-internal-label2.js';
import { d as defineCustomElement$7 } from './wpp-internal-tooltip2.js';
import { d as defineCustomElement$6 } from './wpp-label2.js';
import { d as defineCustomElement$5 } from './wpp-list-item2.js';
import { d as defineCustomElement$4 } from './wpp-spinner2.js';
import { d as defineCustomElement$3 } from './wpp-tooltip2.js';
import { d as defineCustomElement$2 } from './wpp-typography2.js';

var airDatepicker = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t();}(commonjsGlobal,(function(){return function(){var e={d:function(t,i){for(var s in i)e.o(i,s)&&!e.o(t,s)&&Object.defineProperty(t,s,{enumerable:!0,get:i[s]});},o:function(e,t){return Object.prototype.hasOwnProperty.call(e,t)}},t={};e.d(t,{default:function(){return B}});var i={days:"days",months:"months",years:"years",day:"day",month:"month",year:"year",eventChangeViewDate:"changeViewDate",eventChangeCurrentView:"changeCurrentView",eventChangeFocusDate:"changeFocusDate",eventChangeSelectedDate:"changeSelectedDate",eventChangeTime:"changeTime",eventChangeLastSelectedDate:"changeLastSelectedDate",actionSelectDate:"selectDate",actionUnselectDate:"unselectDate",cssClassWeekend:"-weekend-"},s={classes:"",inline:!1,locale:{days:["Воскресенье","Понедельник","Вторник","Среда","Четверг","Пятница","Суббота"],daysShort:["Вос","Пон","Вто","Сре","Чет","Пят","Суб"],daysMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthsShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],today:"Сегодня",clear:"Очистить",dateFormat:"dd.MM.yyyy",timeFormat:"HH:mm",firstDay:1},startDate:new Date,firstDay:"",weekends:[6,0],dateFormat:"",altField:"",altFieldDateFormat:"T",toggleSelected:!0,keyboardNav:!0,selectedDates:!1,container:"",isMobile:!1,visible:!1,position:"bottom left",offset:12,view:i.days,minView:i.days,showOtherMonths:!0,selectOtherMonths:!0,moveToOtherMonthsOnSelect:!0,showOtherYears:!0,selectOtherYears:!0,moveToOtherYearsOnSelect:!0,minDate:"",maxDate:"",disableNavWhenOutOfRange:!0,multipleDates:!1,multipleDatesSeparator:", ",range:!1,dynamicRange:!0,buttons:!1,monthsField:"monthsShort",showEvent:"focus",autoClose:!1,prevHtml:'<svg><path d="M 17,12 l -5,5 l 5,5"></path></svg>',nextHtml:'<svg><path d="M 14,12 l 5,5 l -5,5"></path></svg>',navTitles:{days:"MMMM, <i>yyyy</i>",months:"yyyy",years:"yyyy1 - yyyy2"},timepicker:!1,onlyTimepicker:!1,dateTimeSeparator:" ",timeFormat:"",minHours:0,maxHours:24,minMinutes:0,maxMinutes:59,hoursStep:1,minutesStep:1,onSelect:!1,onChangeViewDate:!1,onChangeView:!1,onRenderCell:!1,onShow:!1,onHide:!1,onClickDayName:!1};function a(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:document;return "string"==typeof e?t.querySelector(e):e}function n(){let{tagName:e="div",className:t="",innerHtml:i="",id:s="",attrs:a={}}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=document.createElement(e);return t&&n.classList.add(...t.split(" ")),s&&(n.id=s),i&&(n.innerHTML=i),a&&r(n,a),n}function r(e,t){for(let[i,s]of Object.entries(t))void 0!==s&&e.setAttribute(i,s);return e}function h(e){return new Date(e.getFullYear(),e.getMonth()+1,0).getDate()}function o(e){let t=e.getHours(),{hours:i,dayPeriod:s}=l(t);return {year:e.getFullYear(),month:e.getMonth(),fullMonth:e.getMonth()+1<10?"0"+(e.getMonth()+1):e.getMonth()+1,date:e.getDate(),fullDate:e.getDate()<10?"0"+e.getDate():e.getDate(),day:e.getDay(),hours:t,fullHours:d(t),hours12:i,dayPeriod:s,fullHours12:d(i),minutes:e.getMinutes(),fullMinutes:e.getMinutes()<10?"0"+e.getMinutes():e.getMinutes()}}function l(e){return {dayPeriod:e>11?"pm":"am",hours:e%12==0?12:e%12}}function d(e){return e<10?"0"+e:e}function c(e){let t=10*Math.floor(e.getFullYear()/10);return [t,t+9]}function u(){let e=[];for(var t=arguments.length,i=new Array(t),s=0;s<t;s++)i[s]=arguments[s];return i.forEach((t=>{if("object"==typeof t)for(let i in t)t[i]&&e.push(i);else t&&e.push(t);})),e.join(" ")}function p(e,t){let s=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.days;if(!e||!t)return !1;let a=o(e),n=o(t);return {[i.days]:a.date===n.date&&a.month===n.month&&a.year===n.year,[i.months]:a.month===n.month&&a.year===n.year,[i.years]:a.year===n.year}[s]}function m(e,t,i){let s=g(e,!1).getTime(),a=g(t,!1).getTime();return i?s>=a:s>a}function v(e,t){return !m(e,t,!0)}function g(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=new Date(e.getTime());return "boolean"!=typeof t||t||function(e){e.setHours(0,0,0,0);}(i),i}function D(e,t,i){e.length?e.forEach((e=>{e.addEventListener(t,i);})):e.addEventListener(t,i);}function y(e,t){return !(!e||e===document||e instanceof DocumentFragment)&&(e.matches(t)?e:y(e.parentNode,t))}function f(e,t,i){return e>i?i:e<t?t:e}function w(e){for(var t=arguments.length,i=new Array(t>1?t-1:0),s=1;s<t;s++)i[s-1]=arguments[s];return i.filter((e=>e)).forEach((t=>{for(let[i,s]of Object.entries(t))if(void 0!==s&&"[object Object]"===s.toString()){let t=void 0!==e[i]?e[i].toString():void 0,a=s.toString(),n=Array.isArray(s)?[]:{};e[i]=e[i]?t!==a?n:e[i]:n,w(e[i],s);}else e[i]=s;})),e}function b(e){let t=e;return e instanceof Date||(t=new Date(e)),isNaN(t.getTime())&&(console.log(`Unable to convert value "${e}" to Date object`),t=!1),t}function k(e){let t="\\s|\\.|-|/|\\\\|,|\\$|\\!|\\?|:|;";return new RegExp("(^|>|"+t+")("+e+")($|<|"+t+")","g")}function $(e,t,i){return (t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,"string");if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return "symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}class C{constructor(){let{type:e,date:t,dp:i,opts:s,body:a}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};$(this,"focus",(()=>{this.$cell.classList.add("-focus-"),this.focused=!0;})),$(this,"removeFocus",(()=>{this.$cell.classList.remove("-focus-"),this.focused=!1;})),$(this,"select",(()=>{this.$cell.classList.add("-selected-"),this.selected=!0;})),$(this,"removeSelect",(()=>{this.$cell.classList.remove("-selected-","-range-from-","-range-to-"),this.selected=!1;})),$(this,"onChangeSelectedDate",(()=>{this.isDisabled||(this._handleSelectedStatus(),this.opts.range&&this._handleRangeStatus());})),$(this,"onChangeFocusDate",(e=>{if(!e)return void(this.focused&&this.removeFocus());let t=p(e,this.date,this.type);t?this.focus():!t&&this.focused&&this.removeFocus(),this.opts.range&&this._handleRangeStatus();})),$(this,"render",(()=>(this.$cell.innerHTML=this._getHtml(),this.$cell.adpCell=this,this.$cell))),this.type=e,this.singleType=this.type.slice(0,-1),this.date=t,this.dp=i,this.opts=s,this.body=a,this.customData=!1,this.init();}init(){let{range:e,onRenderCell:t}=this.opts;t&&(this.customData=t({date:this.date,cellType:this.singleType,datepicker:this.dp})),this._createElement(),this._bindDatepickerEvents(),this._handleInitialFocusStatus(),this.dp.hasSelectedDates&&(this._handleSelectedStatus(),e&&this._handleRangeStatus());}_bindDatepickerEvents(){this.dp.on(i.eventChangeSelectedDate,this.onChangeSelectedDate),this.dp.on(i.eventChangeFocusDate,this.onChangeFocusDate);}unbindDatepickerEvents(){this.dp.off(i.eventChangeSelectedDate,this.onChangeSelectedDate),this.dp.off(i.eventChangeFocusDate,this.onChangeFocusDate);}_createElement(){var e;let{year:t,month:i,date:s}=o(this.date),a=(null===(e=this.customData)||void 0===e?void 0:e.attrs)||{};this.$cell=n({className:this._getClassName(),attrs:{"data-year":t,"data-month":i,"data-date":s,...a}});}_getClassName(){var e,t;let s=new Date,{selectOtherMonths:a,selectOtherYears:n}=this.opts,{minDate:r,maxDate:h}=this.dp,{day:l}=o(this.date),d=this._isOutOfMinMaxRange(),c=null===(e=this.customData)||void 0===e?void 0:e.disabled,m=u("air-datepicker-cell",`-${this.singleType}-`,{"-current-":p(s,this.date,this.type),"-min-date-":r&&p(r,this.date,this.type),"-max-date-":h&&p(h,this.date,this.type)}),v="";switch(this.type){case i.days:v=u({"-weekend-":this.dp.isWeekend(l),"-other-month-":this.isOtherMonth,"-disabled-":this.isOtherMonth&&!a||d||c});break;case i.months:v=u({"-disabled-":d||c});break;case i.years:v=u({"-other-decade-":this.isOtherDecade,"-disabled-":d||this.isOtherDecade&&!n||c});}return u(m,v,null===(t=this.customData)||void 0===t?void 0:t.classes)}_getHtml(){var e;let{year:t,month:s,date:a}=o(this.date),{showOtherMonths:n,showOtherYears:r}=this.opts;if(null!==(e=this.customData)&&void 0!==e&&e.html)return this.customData.html;switch(this.type){case i.days:return !n&&this.isOtherMonth?"":a;case i.months:return this.dp.locale[this.opts.monthsField][s];case i.years:return !r&&this.isOtherDecade?"":t}}_isOutOfMinMaxRange(){let{minDate:e,maxDate:t}=this.dp,{type:s,date:a}=this,{month:n,year:r,date:h}=o(a),l=s===i.days,d=s===i.years,c=!!e&&new Date(r,d?e.getMonth():n,l?h:e.getDate()),u=!!t&&new Date(r,d?t.getMonth():n,l?h:t.getDate());return e&&t?v(c,e)||m(u,t):e?v(c,e):t?m(u,t):void 0}destroy(){this.unbindDatepickerEvents();}_handleRangeStatus(){let{rangeDateFrom:e,rangeDateTo:t}=this.dp,i=u({"-in-range-":e&&t&&(s=this.date,a=e,n=t,m(s,a)&&v(s,n)),"-range-from-":e&&p(this.date,e,this.type),"-range-to-":t&&p(this.date,t,this.type)});var s,a,n;this.$cell.classList.remove("-range-from-","-range-to-","-in-range-"),i&&this.$cell.classList.add(...i.split(" "));}_handleSelectedStatus(){let e=this.dp._checkIfDateIsSelected(this.date,this.type);e?this.select():!e&&this.selected&&this.removeSelect();}_handleInitialFocusStatus(){p(this.dp.focusDate,this.date,this.type)&&this.focus();}get isDisabled(){return this.$cell.matches(".-disabled-")}get isOtherMonth(){return this.dp.isOtherMonth(this.date)}get isOtherDecade(){return this.dp.isOtherDecade(this.date)}}function _(e,t,i){return (t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,"string");if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return "symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}let M={[i.days]:`<div class="air-datepicker-body--day-names"></div><div class="air-datepicker-body--cells -${i.days}-"></div>`,[i.months]:`<div class="air-datepicker-body--cells -${i.months}-"></div>`,[i.years]:`<div class="air-datepicker-body--cells -${i.years}-"></div>`};const S=".air-datepicker-cell";class T{constructor(e){let{dp:t,type:s,opts:a}=e;_(this,"handleClick",(e=>{let t=e.target.closest(S).adpCell;if(t.isDisabled)return;if(!this.dp.isMinViewReached)return void this.dp.down();let i=this.dp._checkIfDateIsSelected(t.date,t.type);i?this.dp._handleAlreadySelectedDates(i,t.date):this.dp.selectDate(t.date);})),_(this,"handleDayNameClick",(e=>{let t=e.target.getAttribute("data-day-index");this.opts.onClickDayName({dayIndex:Number(t),datepicker:this.dp});})),_(this,"onChangeCurrentView",(e=>{e!==this.type?this.hide():(this.show(),this.render());})),_(this,"onMouseOverCell",(e=>{let t=y(e.target,S);this.dp.setFocusDate(!!t&&t.adpCell.date);})),_(this,"onMouseOutCell",(()=>{this.dp.setFocusDate(!1);})),_(this,"onClickBody",(e=>{let{onClickDayName:t}=this.opts,i=e.target;i.closest(S)&&this.handleClick(e),t&&i.closest(".air-datepicker-body--day-name")&&this.handleDayNameClick(e);})),_(this,"onMouseDown",(e=>{this.pressed=!0;let t=y(e.target,S),i=t&&t.adpCell;p(i.date,this.dp.rangeDateFrom)&&(this.rangeFromFocused=!0),p(i.date,this.dp.rangeDateTo)&&(this.rangeToFocused=!0);})),_(this,"onMouseMove",(e=>{if(!this.pressed||!this.dp.isMinViewReached)return;e.preventDefault();let t=y(e.target,S),i=t&&t.adpCell,{selectedDates:s,rangeDateTo:a,rangeDateFrom:n}=this.dp;if(!i||i.isDisabled)return;let{date:r}=i;if(2===s.length){if(this.rangeFromFocused&&!m(r,a)){let{hours:e,minutes:t}=o(n);r.setHours(e),r.setMinutes(t),this.dp.rangeDateFrom=r,this.dp.replaceDate(n,r);}if(this.rangeToFocused&&!v(r,n)){let{hours:e,minutes:t}=o(a);r.setHours(e),r.setMinutes(t),this.dp.rangeDateTo=r,this.dp.replaceDate(a,r);}}})),_(this,"onMouseUp",(()=>{this.pressed=!1,this.rangeFromFocused=!1,this.rangeToFocused=!1;})),_(this,"onChangeViewDate",((e,t)=>{if(!this.isVisible)return;let s=c(e),a=c(t);switch(this.dp.currentView){case i.days:if(p(e,t,i.months))return;break;case i.months:if(p(e,t,i.years))return;break;case i.years:if(s[0]===a[0]&&s[1]===a[1])return}this.render();})),_(this,"render",(()=>{this.destroyCells(),this._generateCells(),this.cells.forEach((e=>{this.$cells.appendChild(e.render());}));})),this.dp=t,this.type=s,this.opts=a,this.cells=[],this.$el="",this.pressed=!1,this.isVisible=!0,this.init();}init(){this._buildBaseHtml(),this.type===i.days&&this.renderDayNames(),this.render(),this._bindEvents(),this._bindDatepickerEvents();}_bindEvents(){let{range:e,dynamicRange:t}=this.opts;D(this.$el,"mouseover",this.onMouseOverCell),D(this.$el,"mouseout",this.onMouseOutCell),D(this.$el,"click",this.onClickBody),e&&t&&(D(this.$el,"mousedown",this.onMouseDown),D(this.$el,"mousemove",this.onMouseMove),D(window.document,"mouseup",this.onMouseUp));}_bindDatepickerEvents(){this.dp.on(i.eventChangeViewDate,this.onChangeViewDate),this.dp.on(i.eventChangeCurrentView,this.onChangeCurrentView);}_buildBaseHtml(){this.$el=n({className:`air-datepicker-body -${this.type}-`,innerHtml:M[this.type]}),this.$names=a(".air-datepicker-body--day-names",this.$el),this.$cells=a(".air-datepicker-body--cells",this.$el);}_getDayNamesHtml(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.dp.locale.firstDay,t="",s=this.dp.isWeekend,{onClickDayName:a}=this.opts,n=e,r=0;for(;r<7;){let e=n%7;t+=`<div class="${u("air-datepicker-body--day-name",{[i.cssClassWeekend]:s(e),"-clickable-":!!a})}" data-day-index='${e}'>${this.dp.locale.daysMin[e]}</div>`,r++,n++;}return t}renderDayNames(){this.$names.innerHTML=this._getDayNamesHtml();}_generateCell(e){let{type:t,dp:i,opts:s}=this;return new C({type:t,dp:i,opts:s,date:e,body:this})}_generateCells(){T.getDatesFunction(this.type)(this.dp,(e=>{this.cells.push(this._generateCell(e));}));}show(){this.isVisible=!0,this.$el.classList.remove("-hidden-");}hide(){this.isVisible=!1,this.$el.classList.add("-hidden-");}destroyCells(){this.cells.forEach((e=>e.destroy())),this.cells=[],this.$cells.innerHTML="";}destroy(){this.destroyCells(),this.dp.off(i.eventChangeViewDate,this.onChangeViewDate),this.dp.off(i.eventChangeCurrentView,this.onChangeCurrentView);}static getDaysDates(e,t){let{viewDate:i,locale:{firstDay:s}}=e,a=h(i),{year:n,month:r}=o(i),l=new Date(n,r,1),d=new Date(n,r,a),c=l.getDay()-s,u=6-d.getDay()+s;c=c<0?c+7:c,u=u>6?u-7:u;let p=function(e,t){let{year:i,month:s,date:a}=o(e);return new Date(i,s,a-t)}(l,c),m=a+c+u,v=p.getDate(),{year:g,month:D}=o(p),y=0;const f=[];for(;y<m;){let e=new Date(g,D,v+y);t&&t(e),f.push(e),y++;}return f}static getMonthsDates(e,t){let{year:i}=e.parsedViewDate,s=0,a=[];for(;s<12;){const e=new Date(i,s);a.push(e),t&&t(e),s++;}return a}static getYearsDates(e,t){let i=c(e.viewDate),s=i[0]-1,a=i[1]+1,n=s,r=[];for(;n<=a;){const e=new Date(n,0);r.push(e),t&&t(e),n++;}return r}static getDatesFunction(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:i.days;return {[i.days]:T.getDaysDates,[i.months]:T.getMonthsDates,[i.years]:T.getYearsDates}[e]}}function F(e,t,i){return (t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,"string");if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return "symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}class V{constructor(e){let{dp:t,opts:i}=e;F(this,"onClickNav",(e=>{let t=y(e.target,".air-datepicker-nav--action");if(!t)return;let i=t.dataset.action;this.dp[i]();})),F(this,"onChangeViewDate",(()=>{this.render(),this._resetNavStatus(),this.handleNavStatus();})),F(this,"onChangeCurrentView",(()=>{this.render(),this._resetNavStatus(),this.handleNavStatus();})),F(this,"onClickNavTitle",(()=>{this.dp.isFinalView||this.dp.up();})),F(this,"update",(()=>{let{prevHtml:e,nextHtml:t}=this.opts;this.$prev.innerHTML=e,this.$next.innerHTML=t,this._resetNavStatus(),this.render(),this.handleNavStatus();})),F(this,"renderDelay",(()=>{setTimeout(this.render);})),F(this,"render",(()=>{this.$title.innerHTML=this._getTitle(),function(e,t){for(let i in t)t[i]?e.classList.add(i):e.classList.remove(i);}(this.$title,{"-disabled-":this.dp.isFinalView});})),this.dp=t,this.opts=i,this.init();}init(){this._createElement(),this._buildBaseHtml(),this._defineDOM(),this.render(),this.handleNavStatus(),this._bindEvents(),this._bindDatepickerEvents();}_defineDOM(){this.$title=a(".air-datepicker-nav--title",this.$el),this.$prev=a('[data-action="prev"]',this.$el),this.$next=a('[data-action="next"]',this.$el);}_bindEvents(){this.$el.addEventListener("click",this.onClickNav),this.$title.addEventListener("click",this.onClickNavTitle);}_bindDatepickerEvents(){this.dp.on(i.eventChangeViewDate,this.onChangeViewDate),this.dp.on(i.eventChangeCurrentView,this.onChangeCurrentView),this.isNavIsFunction&&(this.dp.on(i.eventChangeSelectedDate,this.renderDelay),this.dp.opts.timepicker&&this.dp.on(i.eventChangeTime,this.render));}destroy(){this.dp.off(i.eventChangeViewDate,this.onChangeViewDate),this.dp.off(i.eventChangeCurrentView,this.onChangeCurrentView),this.isNavIsFunction&&(this.dp.off(i.eventChangeSelectedDate,this.renderDelay),this.dp.opts.timepicker&&this.dp.off(i.eventChangeTime,this.render));}_createElement(){this.$el=n({tagName:"nav",className:"air-datepicker-nav"});}_getTitle(){let{dp:e,opts:t}=this,i=t.navTitles[e.currentView];return "function"==typeof i?i(e):e.formatDate(e.viewDate,i)}handleNavStatus(){let{disableNavWhenOutOfRange:e}=this.opts,{minDate:t,maxDate:s}=this.dp;if(!t&&!s||!e)return;let{year:a,month:n}=this.dp.parsedViewDate,r=!!t&&o(t),h=!!s&&o(s);switch(this.dp.currentView){case i.days:t&&r.month>=n&&r.year>=a&&this._disableNav("prev"),s&&h.month<=n&&h.year<=a&&this._disableNav("next");break;case i.months:t&&r.year>=a&&this._disableNav("prev"),s&&h.year<=a&&this._disableNav("next");break;case i.years:{let e=c(this.dp.viewDate);t&&r.year>=e[0]&&this._disableNav("prev"),s&&h.year<=e[1]&&this._disableNav("next");break}}}_disableNav(e){a('[data-action="'+e+'"]',this.$el).classList.add("-disabled-");}_resetNavStatus(){!function(e){for(var t=arguments.length,i=new Array(t>1?t-1:0),s=1;s<t;s++)i[s-1]=arguments[s];e.length?e.forEach((e=>{e.classList.remove(...i);})):e.classList.remove(...i);}(this.$el.querySelectorAll(".air-datepicker-nav--action"),"-disabled-");}_buildBaseHtml(){let{prevHtml:e,nextHtml:t}=this.opts;this.$el.innerHTML=`<div class="air-datepicker-nav--action" data-action="prev">${e}</div><div class="air-datepicker-nav--title"></div><div class="air-datepicker-nav--action" data-action="next">${t}</div>`;}get isNavIsFunction(){let{navTitles:e}=this.opts;return Object.keys(e).find((t=>"function"==typeof e[t]))}}var x={today:{content:e=>e.locale.today,onClick:e=>e.setViewDate(new Date)},clear:{content:e=>e.locale.clear,onClick:e=>e.clear()}};class H{constructor(e){let{dp:t,opts:i}=e;this.dp=t,this.opts=i,this.init();}init(){this.createElement(),this.render();}createElement(){this.$el=n({className:"air-datepicker-buttons"});}destroy(){this.$el.parentNode.removeChild(this.$el);}clearHtml(){return this.$el.innerHTML="",this}generateButtons(){let{buttons:e}=this.opts;Array.isArray(e)||(e=[e]),e.forEach((e=>{let t=e;"string"==typeof e&&x[e]&&(t=x[e]);let i=this.createButton(t);t.onClick&&this.attachEventToButton(i,t.onClick),this.$el.appendChild(i);}));}attachEventToButton(e,t){e.addEventListener("click",(()=>{t(this.dp);}));}createButton(e){let{content:t,className:i,tagName:s="button",attrs:a={}}=e;return n({tagName:s,innerHtml:`<span tabindex='-1'>${"function"==typeof t?t(this.dp):t}</span>`,className:u("air-datepicker-button",i),attrs:a})}render(){this.generateButtons();}}function E(e,t,i){return (t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,"string");if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return "symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}class L{constructor(){let{opts:e,dp:t}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};E(this,"toggleTimepickerIsActive",(e=>{this.dp.timepickerIsActive=e;})),E(this,"onChangeSelectedDate",(e=>{let{date:t,updateTime:i=!1}=e;t&&(this.setMinMaxTime(t),this.setCurrentTime(!!i&&t),this.addTimeToDate(t));})),E(this,"onChangeLastSelectedDate",(e=>{e&&(this.setTime(e),this.render());})),E(this,"onChangeInputRange",(e=>{let t=e.target;this[t.getAttribute("name")]=t.value,this.updateText(),this.dp.trigger(i.eventChangeTime,{hours:this.hours,minutes:this.minutes});})),E(this,"onMouseEnterLeave",(e=>{let t=e.target.getAttribute("name"),i=this.$minutesText;"hours"===t&&(i=this.$hoursText),i.classList.toggle("-focus-");})),E(this,"onFocus",(()=>{this.toggleTimepickerIsActive(!0);})),E(this,"onBlur",(()=>{this.toggleTimepickerIsActive(!1);})),this.opts=e,this.dp=t;let{timeFormat:s}=this.dp.locale;s&&(s.match(k("h"))||s.match(k("hh")))&&(this.ampm=!0),this.init();}init(){this.setTime(this.dp.lastSelectedDate||this.dp.viewDate),this.createElement(),this.buildHtml(),this.defineDOM(),this.render(),this.bindDatepickerEvents(),this.bindDOMEvents();}bindDatepickerEvents(){this.dp.on(i.eventChangeSelectedDate,this.onChangeSelectedDate),this.dp.on(i.eventChangeLastSelectedDate,this.onChangeLastSelectedDate);}bindDOMEvents(){let e="input";navigator.userAgent.match(/trident/gi)&&(e="change"),D(this.$ranges,e,this.onChangeInputRange),D(this.$ranges,"mouseenter",this.onMouseEnterLeave),D(this.$ranges,"mouseleave",this.onMouseEnterLeave),D(this.$ranges,"focus",this.onFocus),D(this.$ranges,"mousedown",this.onFocus),D(this.$ranges,"blur",this.onBlur);}createElement(){this.$el=n({className:u("air-datepicker-time",{"-am-pm-":this.dp.ampm})});}destroy(){this.dp.off(i.eventChangeSelectedDate,this.onChangeSelectedDate),this.dp.off(i.eventChangeLastSelectedDate,this.onChangeLastSelectedDate),this.$el.parentNode.removeChild(this.$el);}buildHtml(){let{ampm:e,hours:t,displayHours:i,minutes:s,minHours:a,minMinutes:n,maxHours:r,maxMinutes:h,dayPeriod:o,opts:{hoursStep:l,minutesStep:c}}=this;this.$el.innerHTML=`<div class="air-datepicker-time--current">   <span class="air-datepicker-time--current-hours">${d(i)}</span>   <span class="air-datepicker-time--current-colon">:</span>   <span class="air-datepicker-time--current-minutes">${d(s)}</span>   `+(e?`<span class='air-datepicker-time--current-ampm'>${o}</span>`:"")+'</div><div class="air-datepicker-time--sliders">   <div class="air-datepicker-time--row">'+`      <input type="range" name="hours" value="${t}" min="${a}" max="${r}" step="${l}"/>   </div>   <div class="air-datepicker-time--row">`+`      <input type="range" name="minutes" value="${s}" min="${n}" max="${h}" step="${c}"/>   </div></div>`;}defineDOM(){let e=e=>a(e,this.$el);this.$ranges=this.$el.querySelectorAll('[type="range"]'),this.$hours=e('[name="hours"]'),this.$minutes=e('[name="minutes"]'),this.$hoursText=e(".air-datepicker-time--current-hours"),this.$minutesText=e(".air-datepicker-time--current-minutes"),this.$ampm=e(".air-datepicker-time--current-ampm");}setTime(e){this.setMinMaxTime(e),this.setCurrentTime(e);}addTimeToDate(e){e&&(e.setHours(this.hours),e.setMinutes(this.minutes));}setMinMaxTime(e){if(this.setMinMaxTimeFromOptions(),e){let{minDate:t,maxDate:i}=this.dp;t&&p(e,t)&&this.setMinTimeFromMinDate(t),i&&p(e,i)&&this.setMaxTimeFromMaxDate(i);}}setCurrentTime(e){let{hours:t,minutes:i}=e?o(e):this;this.hours=f(t,this.minHours,this.maxHours),this.minutes=f(i,this.minMinutes,this.maxMinutes);}setMinMaxTimeFromOptions(){let{minHours:e,minMinutes:t,maxHours:i,maxMinutes:s}=this.opts;this.minHours=f(e,0,23),this.minMinutes=f(t,0,59),this.maxHours=f(i,0,23),this.maxMinutes=f(s,0,59);}setMinTimeFromMinDate(e){let{lastSelectedDate:t}=this.dp;this.minHours=e.getHours(),t&&t.getHours()>e.getHours()?this.minMinutes=this.opts.minMinutes:this.minMinutes=e.getMinutes();}setMaxTimeFromMaxDate(e){let{lastSelectedDate:t}=this.dp;this.maxHours=e.getHours(),t&&t.getHours()<e.getHours()?this.maxMinutes=this.opts.maxMinutes:this.maxMinutes=e.getMinutes();}updateSliders(){r(this.$hours,{min:this.minHours,max:this.maxHours}).value=this.hours,r(this.$minutes,{min:this.minMinutes,max:this.maxMinutes}).value=this.minutes;}updateText(){this.$hoursText.innerHTML=d(this.displayHours),this.$minutesText.innerHTML=d(this.minutes),this.ampm&&(this.$ampm.innerHTML=this.dayPeriod);}set hours(e){this._hours=e;let{hours:t,dayPeriod:i}=l(e);this.displayHours=this.ampm?t:e,this.dayPeriod=i;}get hours(){return this._hours}render(){this.updateSliders(),this.updateText();}}function O(e,t,i){return (t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,"string");if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return "symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}class A{constructor(e){let{dp:t,opts:i}=e;O(this,"pressedKeys",new Set),O(this,"hotKeys",new Map([[[["Control","ArrowRight"],["Control","ArrowUp"]],e=>e.month++],[[["Control","ArrowLeft"],["Control","ArrowDown"]],e=>e.month--],[[["Shift","ArrowRight"],["Shift","ArrowUp"]],e=>e.year++],[[["Shift","ArrowLeft"],["Shift","ArrowDown"]],e=>e.year--],[[["Alt","ArrowRight"],["Alt","ArrowUp"]],e=>e.year+=10],[[["Alt","ArrowLeft"],["Alt","ArrowDown"]],e=>e.year-=10],[["Control","Shift","ArrowUp"],(e,t)=>t.up()]])),O(this,"handleHotKey",(e=>{let t=this.hotKeys.get(e),i=o(this.getInitialFocusDate());t(i,this.dp);let{year:s,month:a,date:n}=i,r=h(new Date(s,a));r<n&&(n=r);let l=this.dp.getClampedDate(new Date(s,a,n));this.dp.setFocusDate(l,{viewDateTransition:!0});})),O(this,"isHotKeyPressed",(()=>{let e=!1,t=this.pressedKeys.size,i=e=>this.pressedKeys.has(e);for(let[s]of this.hotKeys){if(e)break;if(Array.isArray(s[0]))s.forEach((a=>{e||t!==a.length||(e=a.every(i)&&s);}));else {if(t!==s.length)continue;e=s.every(i)&&s;}}return e})),O(this,"isArrow",(e=>e>=37&&e<=40)),O(this,"onKeyDown",(e=>{let{key:t,which:i}=e,{dp:s,dp:{focusDate:a},opts:n}=this;this.registerKey(t);let r=this.isHotKeyPressed();if(r)return e.preventDefault(),void this.handleHotKey(r);if(this.isArrow(i))return e.preventDefault(),void this.focusNextCell(t);if("Enter"===t){if(s.currentView!==n.minView)return void s.down();if(a){let e=s._checkIfDateIsSelected(a);return void(e?s._handleAlreadySelectedDates(e,a):s.selectDate(a))}}"Escape"===t&&this.dp.hide();})),O(this,"onKeyUp",(e=>{this.removeKey(e.key);})),this.dp=t,this.opts=i,this.init();}init(){this.bindKeyboardEvents();}bindKeyboardEvents(){let{$el:e}=this.dp;e.addEventListener("keydown",this.onKeyDown),e.addEventListener("keyup",this.onKeyUp);}destroy(){let{$el:e}=this.dp;e.removeEventListener("keydown",this.onKeyDown),e.removeEventListener("keyup",this.onKeyUp),this.hotKeys=null,this.pressedKeys=null;}getInitialFocusDate(){let{focusDate:e,currentView:t,selectedDates:s,parsedViewDate:{year:a,month:n}}=this.dp,r=e||s[s.length-1];if(!r)switch(t){case i.days:r=new Date(a,n,(new Date).getDate());break;case i.months:r=new Date(a,n,1);break;case i.years:r=new Date(a,0,1);}return r}focusNextCell(e){let t=this.getInitialFocusDate(),{currentView:s}=this.dp,{days:a,months:n,years:r}=i,h=o(t),l=h.year,d=h.month,c=h.date;switch(e){case"ArrowLeft":s===a&&(c-=1),s===n&&(d-=1),s===r&&(l-=1);break;case"ArrowUp":s===a&&(c-=7),s===n&&(d-=3),s===r&&(l-=4);break;case"ArrowRight":s===a&&(c+=1),s===n&&(d+=1),s===r&&(l+=1);break;case"ArrowDown":s===a&&(c+=7),s===n&&(d+=3),s===r&&(l+=4);}let u=this.dp.getClampedDate(new Date(l,d,c));this.dp.setFocusDate(u,{viewDateTransition:!0});}registerKey(e){this.pressedKeys.add(e);}removeKey(e){this.pressedKeys.delete(e);}}let N={on(e,t){this.__events||(this.__events={}),this.__events[e]?this.__events[e].push(t):this.__events[e]=[t];},off(e,t){this.__events&&this.__events[e]&&(this.__events[e]=this.__events[e].filter((e=>e!==t)));},removeAllEvents(){this.__events={};},trigger(e){for(var t=arguments.length,i=new Array(t>1?t-1:0),s=1;s<t;s++)i[s-1]=arguments[s];this.__events&&this.__events[e]&&this.__events[e].forEach((e=>{e(...i);}));}};function I(e,t,i){return (t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var i=e[Symbol.toPrimitive];if(void 0!==i){var s=i.call(e,"string");if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(e)}(e);return "symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}let P="",j="",R=!1;class B{static buildGlobalContainer(e){R=!0,P=n({className:e,id:e}),a("body").appendChild(P);}constructor(e,t){var r=this;if(I(this,"viewIndexes",[i.days,i.months,i.years]),I(this,"next",(()=>{let{year:e,month:t}=this.parsedViewDate;switch(this.currentView){case i.days:this.setViewDate(new Date(e,t+1,1));break;case i.months:this.setViewDate(new Date(e+1,t,1));break;case i.years:this.setViewDate(new Date(e+10,0,1));}})),I(this,"prev",(()=>{let{year:e,month:t}=this.parsedViewDate;switch(this.currentView){case i.days:this.setViewDate(new Date(e,t-1,1));break;case i.months:this.setViewDate(new Date(e-1,t,1));break;case i.years:this.setViewDate(new Date(e-10,0,1));}})),I(this,"_finishHide",(()=>{this.hideAnimation=!1,this._destroyComponents(),this.$container.removeChild(this.$datepicker);})),I(this,"setPosition",(function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if("function"==typeof(e=e||r.opts.position))return void(r.customHide=e({$datepicker:r.$datepicker,$target:r.$el,$pointer:r.$pointer,isViewChange:t,done:r._finishHide}));let i,s,{isMobile:a}=r.opts,n=r.$el.getBoundingClientRect(),h=r.$el.getBoundingClientRect(),o=r.$datepicker.offsetParent,l=r.$el.offsetParent,d=r.$datepicker.getBoundingClientRect(),c=e.split(" "),u=window.scrollY,p=window.scrollX,m=r.opts.offset,v=c[0],g=c[1];if(a)r.$datepicker.style.cssText="left: 50%; top: 50%";else {if(o===l&&o!==document.body&&(h={top:r.$el.offsetTop,left:r.$el.offsetLeft,width:n.width,height:r.$el.offsetHeight},u=0,p=0),o!==l&&o!==document.body){let e=o.getBoundingClientRect();h={top:n.top-e.top,left:n.left-e.left,width:n.width,height:n.height},u=0,p=0;}switch(v){case"top":i=h.top-d.height-m;break;case"right":s=h.left+h.width+m;break;case"bottom":i=h.top+h.height+m;break;case"left":s=h.left-d.width-m;}switch(g){case"top":i=h.top;break;case"right":s=h.left+h.width-d.width;break;case"bottom":i=h.top+h.height-d.height;break;case"left":s=h.left;break;case"center":/left|right/.test(v)?i=h.top+h.height/2-d.height/2:s=h.left+h.width/2-d.width/2;}r.$datepicker.style.cssText=`left: ${s+p}px; top: ${i+u}px`;}})),I(this,"_setInputValue",(()=>{let{opts:e,$altField:t,locale:{dateFormat:i}}=this,{altFieldDateFormat:s,altField:a}=e;a&&t&&(t.value=this._getInputValue(s)),this.$el.value=this._getInputValue(i);})),I(this,"_getInputValue",(e=>{let{selectedDates:t,opts:i}=this,{multipleDates:s,multipleDatesSeparator:a}=i;if(!t.length)return "";let n="function"==typeof e,r=n?e(s?t:t[0]):t.map((t=>this.formatDate(t,e)));return r=n?r:r.join(a),r})),I(this,"_checkIfDateIsSelected",(function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i.days,s=!1;return r.selectedDates.some((i=>{let a=p(e,i,t);return s=a&&i,a})),s})),I(this,"_scheduleCallAfterTransition",(e=>{this._cancelScheduledCall(),e&&e(!1),this._onTransitionEnd=()=>{e&&e(!0);},this.$datepicker.addEventListener("transitionend",this._onTransitionEnd,{once:!0});})),I(this,"_cancelScheduledCall",(()=>{this.$datepicker.removeEventListener("transitionend",this._onTransitionEnd);})),I(this,"setViewDate",(e=>{if(!((e=b(e))instanceof Date))return;if(p(e,this.viewDate))return;let t=this.viewDate;this.viewDate=e;let{onChangeViewDate:s}=this.opts;if(s){let{month:e,year:t}=this.parsedViewDate;s({month:e,year:t,decade:this.curDecade});}this.trigger(i.eventChangeViewDate,e,t);})),I(this,"setFocusDate",(function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(!e||(e=b(e))instanceof Date)&&(r.focusDate=e,r.opts.range&&e&&r._handleRangeOnFocus(),r.trigger(i.eventChangeFocusDate,e,t));})),I(this,"setCurrentView",(e=>{if(this.viewIndexes.includes(e)){if(this.currentView=e,this.elIsInput&&this.visible&&this.setPosition(void 0,!0),this.trigger(i.eventChangeCurrentView,e),!this.views[e]){let t=this.views[e]=new T({dp:this,opts:this.opts,type:e});this.shouldUpdateDOM&&this.$content.appendChild(t.$el);}this.opts.onChangeView&&this.opts.onChangeView(e);}})),I(this,"_updateLastSelectedDate",(e=>{this.lastSelectedDate=e,this.trigger(i.eventChangeLastSelectedDate,e);})),I(this,"destroy",(()=>{let{showEvent:e,isMobile:t}=this.opts,i=this.$datepicker.parentNode;i&&i.removeChild(this.$datepicker),this.$el.removeEventListener(e,this._onFocus),this.$el.removeEventListener("blur",this._onBlur),window.removeEventListener("resize",this._onResize),t&&this._removeMobileAttributes(),this.keyboardNav&&this.keyboardNav.destroy(),this.views=null,this.nav=null,this.$datepicker=null,this.opts=null,this.$customContainer=null,this.viewDate=null,this.focusDate=null,this.selectedDates=null,this.rangeDateFrom=null,this.rangeDateTo=null;})),I(this,"update",(function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=w({},r.opts);w(r.opts,e);let{timepicker:s,buttons:a,range:n,selectedDates:h,isMobile:o}=r.opts,l=r.visible||r.treatAsInline;r._createMinMaxDates(),r._limitViewDateByMaxMinDates(),r._handleLocale(),!t.selectedDates&&h&&r.selectDate(h),e.view&&r.setCurrentView(e.view),r._setInputValue(),t.range&&!n?(r.rangeDateTo=!1,r.rangeDateFrom=!1):!t.range&&n&&r.selectedDates.length&&(r.rangeDateFrom=r.selectedDates[0],r.rangeDateTo=r.selectedDates[1]),t.timepicker&&!s?(l&&r.timepicker.destroy(),r.timepicker=!1,r.$timepicker.parentNode.removeChild(r.$timepicker)):!t.timepicker&&s&&r._addTimepicker(),!t.buttons&&a?r._addButtons():t.buttons&&!a?(r.buttons.destroy(),r.$buttons.parentNode.removeChild(r.$buttons)):l&&t.buttons&&a&&r.buttons.clearHtml().render(),!t.isMobile&&o?(r.treatAsInline||j||r._createMobileOverlay(),r._addMobileAttributes(),r.visible&&r._showMobileOverlay()):t.isMobile&&!o&&(r._removeMobileAttributes(),r.visible&&(j.classList.remove("-active-"),"function"!=typeof r.opts.position&&r.setPosition())),l&&(r.nav.update(),r.views[r.currentView].render(),r.currentView===i.days&&r.views[r.currentView].renderDayNames());})),I(this,"isOtherMonth",(e=>{let{month:t}=o(e);return t!==this.parsedViewDate.month})),I(this,"isOtherYear",(e=>{let{year:t}=o(e);return t!==this.parsedViewDate.year})),I(this,"isOtherDecade",(e=>{let{year:t}=o(e),[i,s]=c(this.viewDate);return t<i||t>s})),I(this,"_onChangeSelectedDate",(e=>{let{silent:t}=e;setTimeout((()=>{this._setInputValue(),this.opts.onSelect&&!t&&this._triggerOnSelect();}));})),I(this,"_onChangeFocusedDate",(function(e){let{viewDateTransition:t}=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!e)return;let i=!1;t&&(i=r.isOtherMonth(e)||r.isOtherYear(e)||r.isOtherDecade(e)),i&&r.setViewDate(e),r.opts.onFocus&&r.opts.onFocus({datepicker:r,date:e});})),I(this,"_onChangeTime",(e=>{let{hours:t,minutes:i}=e,s=new Date,{lastSelectedDate:a,opts:{onSelect:n}}=this,r=a;a||(r=s);let h=this.getCell(r,this.currentViewSingular),o=h&&h.adpCell;o&&o.isDisabled||(r.setHours(t),r.setMinutes(i),a?(this._setInputValue(),n&&this._triggerOnSelect()):this.selectDate(r));})),I(this,"_onFocus",(e=>{this.visible||this.show();})),I(this,"_onBlur",(e=>{this.inFocus||!this.visible||this.opts.isMobile||this.hide();})),I(this,"_onMouseDown",(e=>{this.inFocus=!0;})),I(this,"_onMouseUp",(e=>{this.inFocus=!1,this.$el.focus();})),I(this,"_onResize",(()=>{this.visible&&"function"!=typeof this.opts.position&&this.setPosition();})),I(this,"_onClickOverlay",(()=>{this.visible&&this.hide();})),I(this,"getViewDates",(function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:i.days;return T.getDatesFunction(e)(r)})),I(this,"isWeekend",(e=>this.opts.weekends.includes(e))),I(this,"getClampedDate",(e=>{let{minDate:t,maxDate:i}=this,s=e;return i&&m(e,i)?s=i:t&&v(e,t)&&(s=t),s})),this.$el=a(e),!this.$el)return;this.$datepicker=n({className:"air-datepicker"}),this.opts=w({},s,t),this.$customContainer=!!this.opts.container&&a(this.opts.container),this.$altField=a(this.opts.altField||!1);let{view:h,startDate:l}=this.opts;l||(this.opts.startDate=new Date),"INPUT"===this.$el.nodeName&&(this.elIsInput=!0),this.inited=!1,this.visible=!1,this.viewDate=b(this.opts.startDate),this.focusDate=!1,this.initialReadonly=this.$el.getAttribute("readonly"),this.customHide=!1,this.currentView=h,this.selectedDates=[],this.views={},this.keys=[],this.rangeDateFrom="",this.rangeDateTo="",this.timepickerIsActive=!1,this.treatAsInline=this.opts.inline||!this.elIsInput,this.init();}init(){let{opts:e,treatAsInline:t,opts:{inline:i,isMobile:s,selectedDates:n,keyboardNav:r,onlyTimepicker:h}}=this,o=a("body");(!R||R&&P&&!o.contains(P))&&!i&&this.elIsInput&&!this.$customContainer&&B.buildGlobalContainer(B.defaultGlobalContainerId),!s||j||t||this._createMobileOverlay(),this._handleLocale(),this._bindSubEvents(),this._createMinMaxDates(),this._limitViewDateByMaxMinDates(),this.elIsInput&&(i||this._bindEvents(),r&&!h&&(this.keyboardNav=new A({dp:this,opts:e}))),n&&this.selectDate(n,{silent:!0}),this.opts.visible&&!t&&this.show(),s&&!t&&this.$el.setAttribute("readonly",!0),t&&this._createComponents();}_createMobileOverlay(){j=n({className:"air-datepicker-overlay"}),P.appendChild(j);}_createComponents(){let{opts:e,treatAsInline:t,opts:{inline:i,buttons:s,timepicker:a,position:n,classes:r,onlyTimepicker:h,isMobile:o}}=this;this._buildBaseHtml(),this.elIsInput&&(i||this._setPositionClasses(n)),!i&&this.elIsInput||this.$datepicker.classList.add("-inline-"),r&&this.$datepicker.classList.add(...r.split(" ")),h&&this.$datepicker.classList.add("-only-timepicker-"),o&&!t&&this._addMobileAttributes(),this.views[this.currentView]=new T({dp:this,type:this.currentView,opts:e}),this.nav=new V({dp:this,opts:e}),a&&this._addTimepicker(),s&&this._addButtons(),this.$content.appendChild(this.views[this.currentView].$el),this.$nav.appendChild(this.nav.$el);}_destroyComponents(){for(let e in this.views)this.views[e].destroy();this.views={},this.nav.destroy(),this.timepicker&&this.timepicker.destroy();}_addMobileAttributes(){j.addEventListener("click",this._onClickOverlay),this.$datepicker.classList.add("-is-mobile-"),this.$el.setAttribute("readonly",!0);}_removeMobileAttributes(){j.removeEventListener("click",this._onClickOverlay),this.$datepicker.classList.remove("-is-mobile-"),this.initialReadonly||""===this.initialReadonly||this.$el.removeAttribute("readonly");}_createMinMaxDates(){let{minDate:e,maxDate:t}=this.opts;this.minDate=!!e&&b(e),this.maxDate=!!t&&b(t);}_addTimepicker(){this.$timepicker=n({className:"air-datepicker--time"}),this.$datepicker.appendChild(this.$timepicker),this.timepicker=new L({dp:this,opts:this.opts}),this.$timepicker.appendChild(this.timepicker.$el);}_addButtons(){this.$buttons=n({className:"air-datepicker--buttons"}),this.$datepicker.appendChild(this.$buttons),this.buttons=new H({dp:this,opts:this.opts}),this.$buttons.appendChild(this.buttons.$el);}_bindSubEvents(){this.on(i.eventChangeSelectedDate,this._onChangeSelectedDate),this.on(i.eventChangeFocusDate,this._onChangeFocusedDate),this.on(i.eventChangeTime,this._onChangeTime);}_buildBaseHtml(){let{inline:e}=this.opts;var t,i;this.elIsInput?e?(t=this.$datepicker,(i=this.$el).parentNode.insertBefore(t,i.nextSibling)):this.$container.appendChild(this.$datepicker):this.$el.appendChild(this.$datepicker),this.$datepicker.innerHTML='<i class="air-datepicker--pointer"></i><div class="air-datepicker--navigation"></div><div class="air-datepicker--content"></div>',this.$content=a(".air-datepicker--content",this.$datepicker),this.$pointer=a(".air-datepicker--pointer",this.$datepicker),this.$nav=a(".air-datepicker--navigation",this.$datepicker);}_handleLocale(){let{locale:e,dateFormat:t,firstDay:i,timepicker:s,onlyTimepicker:a,timeFormat:n,dateTimeSeparator:r}=this.opts;var h;this.locale=(h=e,JSON.parse(JSON.stringify(h))),t&&(this.locale.dateFormat=t),void 0!==n&&""!==n&&(this.locale.timeFormat=n);let{timeFormat:o}=this.locale;if(""!==i&&(this.locale.firstDay=i),s&&"function"!=typeof t){let e=o?r:"";this.locale.dateFormat=[this.locale.dateFormat,o||""].join(e);}a&&"function"!=typeof t&&(this.locale.dateFormat=this.locale.timeFormat);}_setPositionClasses(e){if("function"==typeof e)return void this.$datepicker.classList.add("-custom-position-");let t=(e=e.split(" "))[0],i=`air-datepicker -${t}-${e[1]}- -from-${t}-`;this.$datepicker.classList.add(...i.split(" "));}_bindEvents(){this.$el.addEventListener(this.opts.showEvent,this._onFocus),this.$el.addEventListener("blur",this._onBlur),this.$datepicker.addEventListener("mousedown",this._onMouseDown),this.$datepicker.addEventListener("mouseup",this._onMouseUp),window.addEventListener("resize",this._onResize);}_limitViewDateByMaxMinDates(){let{viewDate:e,minDate:t,maxDate:i}=this;i&&m(e,i)&&this.setViewDate(i),t&&v(e,t)&&this.setViewDate(t);}formatDate(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.viewDate,t=arguments.length>1?arguments[1]:void 0;if(e=b(e),!(e instanceof Date))return;let i=t,s=this.locale,a=o(e),n=a.dayPeriod,r=c(e),h=B.replacer,l={T:e.getTime(),m:a.minutes,mm:a.fullMinutes,h:a.hours12,hh:a.fullHours12,H:a.hours,HH:a.fullHours,aa:n,AA:n.toUpperCase(),E:s.daysShort[a.day],EEEE:s.days[a.day],d:a.date,dd:a.fullDate,M:a.month+1,MM:a.fullMonth,MMM:s.monthsShort[a.month],MMMM:s.months[a.month],yy:a.year.toString().slice(-2),yyyy:a.year,yyyy1:r[0],yyyy2:r[1]};for(let[e,t]of Object.entries(l))i=h(i,k(e),t);return i}down(e){this._handleUpDownActions(e,"down");}up(e){this._handleUpDownActions(e,"up");}selectDate(e){let t,s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{currentView:a,parsedViewDate:n,selectedDates:r}=this,{updateTime:h}=s,{moveToOtherMonthsOnSelect:o,moveToOtherYearsOnSelect:l,multipleDates:d,range:c,autoClose:u,onBeforeSelect:p}=this.opts,v=r.length;if(Array.isArray(e))return e.forEach((e=>{this.selectDate(e,s);})),new Promise((e=>{setTimeout(e);}));if((e=b(e))instanceof Date){if(p&&!p({date:e,datepicker:this}))return Promise.resolve();if(a===i.days&&e.getMonth()!==n.month&&o&&(t=new Date(e.getFullYear(),e.getMonth(),1)),a===i.years&&e.getFullYear()!==n.year&&l&&(t=new Date(e.getFullYear(),0,1)),t&&this.setViewDate(t),d&&!c){if(v===d)return;this._checkIfDateIsSelected(e)||r.push(e);}else if(c)switch(v){case 1:r.push(e),this.rangeDateTo||(this.rangeDateTo=e),m(this.rangeDateFrom,this.rangeDateTo)&&(this.rangeDateTo=this.rangeDateFrom,this.rangeDateFrom=e),this.selectedDates=[this.rangeDateFrom,this.rangeDateTo];break;case 2:this.selectedDates=[e],this.rangeDateFrom=e,this.rangeDateTo="";break;default:this.selectedDates=[e],this.rangeDateFrom=e;}else this.selectedDates=[e];return this.trigger(i.eventChangeSelectedDate,{action:i.actionSelectDate,silent:null==s?void 0:s.silent,date:e,updateTime:h}),this._updateLastSelectedDate(e),u&&!this.timepickerIsActive&&this.visible&&(d||c?c&&1===v&&this.hide():this.hide()),new Promise((e=>{setTimeout(e);}))}}unselectDate(e){let t=this.selectedDates,s=this;if((e=b(e))instanceof Date)return t.some(((a,n)=>{if(p(a,e))return t.splice(n,1),s.selectedDates.length?s._updateLastSelectedDate(s.selectedDates[s.selectedDates.length-1]):(s.rangeDateFrom="",s.rangeDateTo="",s._updateLastSelectedDate(!1)),this.trigger(i.eventChangeSelectedDate,{action:i.actionUnselectDate,date:e}),!0}))}replaceDate(e,t){let s=this.selectedDates.find((t=>p(t,e,this.currentView))),a=this.selectedDates.indexOf(s);a<0||p(this.selectedDates[a],t,this.currentView)||(this.selectedDates[a]=t,this.trigger(i.eventChangeSelectedDate,{action:i.actionSelectDate,date:t,updateTime:!0}),this._updateLastSelectedDate(t));}clear(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.selectedDates=[],this.rangeDateFrom=!1,this.rangeDateTo=!1,this.lastSelectedDate=!1,this.trigger(i.eventChangeSelectedDate,{action:i.actionUnselectDate,silent:e.silent}),new Promise((e=>{setTimeout(e);}))}show(){let{onShow:e,isMobile:t}=this.opts;this._cancelScheduledCall(),this.visible||this.hideAnimation||this._createComponents(),this.setPosition(this.opts.position),this.$datepicker.classList.add("-active-"),this.visible=!0,e&&this._scheduleCallAfterTransition(e),t&&this._showMobileOverlay();}hide(){let{onHide:e,isMobile:t}=this.opts,i=this._hasTransition();this.visible=!1,this.hideAnimation=!0,this.$datepicker.classList.remove("-active-"),this.customHide&&this.customHide(),this.elIsInput&&this.$el.blur(),this._scheduleCallAfterTransition((t=>{!this.customHide&&(t&&i||!t&&!i)&&this._finishHide(),e&&e(t);})),t&&j.classList.remove("-active-");}_triggerOnSelect(){let e=[],t=[],{selectedDates:i,locale:s,opts:{onSelect:a,multipleDates:n,range:r}}=this,h=n||r,o="function"==typeof s.dateFormat;i.length&&(e=i.map(g),t=o?n?s.dateFormat(e):e.map((e=>s.dateFormat(e))):e.map((e=>this.formatDate(e,s.dateFormat)))),a({date:h?e:e[0],formattedDate:h?t:t[0],datepicker:this});}_handleAlreadySelectedDates(e,t){const{range:i,toggleSelected:s}=this.opts;let a="function"==typeof s?s({datepicker:this,date:t}):s;i&&(a||2!==this.selectedDates.length&&this.selectDate(t)),a?this.unselectDate(t):this._updateLastSelectedDate(e);}_handleUpDownActions(e,t){if(!((e=b(e||this.focusDate||this.viewDate))instanceof Date))return;let i="up"===t?this.viewIndex+1:this.viewIndex-1;i>2&&(i=2),i<0&&(i=0),this.setViewDate(new Date(e.getFullYear(),e.getMonth(),1)),this.setCurrentView(this.viewIndexes[i]);}_handleRangeOnFocus(){1===this.selectedDates.length&&(m(this.selectedDates[0],this.focusDate)?(this.rangeDateTo=this.selectedDates[0],this.rangeDateFrom=this.focusDate):(this.rangeDateTo=this.focusDate,this.rangeDateFrom=this.selectedDates[0]));}getCell(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i.day;if(!((e=b(e))instanceof Date))return;let{year:s,month:a,date:n}=o(e),r=`[data-year="${s}"]`,h=`[data-month="${a}"]`,l={[i.day]:`${r}${h}[data-date="${n}"]`,[i.month]:`${r}${h}`,[i.year]:`${r}`};return this.views[this.currentView].$el.querySelector(l[t])}_showMobileOverlay(){j.classList.add("-active-");}_hasTransition(){return window.getComputedStyle(this.$datepicker).getPropertyValue("transition-duration").split(", ").reduce(((e,t)=>parseFloat(t)+e),0)>0}get shouldUpdateDOM(){return this.visible||this.treatAsInline}get parsedViewDate(){return o(this.viewDate)}get currentViewSingular(){return this.currentView.slice(0,-1)}get curDecade(){return c(this.viewDate)}get viewIndex(){return this.viewIndexes.indexOf(this.currentView)}get isFinalView(){return this.currentView===i.years}get hasSelectedDates(){return this.selectedDates.length>0}get isMinViewReached(){return this.currentView===this.opts.minView||this.currentView===i.days}get $container(){return this.$customContainer||P}static replacer(e,t,i){return e.replace(t,(function(e,t,s,a){return t+i+a}))}}var K;return I(B,"defaults",s),I(B,"version","3.4.0"),I(B,"defaultGlobalContainerId","air-datepicker-global-container"),K=B.prototype,Object.assign(K,N),t.default}()}));
});

var en = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  today: 'Today',
  clear: 'Clear',
  dateFormat: 'MM/dd/yyyy',
  timeFormat: 'hh:mm aa',
  firstDay: 0
};
exports.default = _default;
});

const defaultLocale = /*@__PURE__*/getDefaultExportFromCjs(en);

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == dateTag;
}

var _baseIsDate = baseIsDate;

/* Node.js helper references. */
var nodeIsDate = _nodeUtil && _nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? _baseUnary(nodeIsDate) : _baseIsDate;

var isDate_1 = isDate;

const DATE_FORMAT = {
  DAY_MONTH_YEAR: 'dd/MM/yyyy',
  MONTH_DAY_YEAR: 'MM/dd/yyyy',
  YEAR_MONTH_DAY: 'yyyy/MM/dd',
};
const DATE_FORMAT_SEPARATOR_PATTERN = /[- /.]/;
const DATES_SEPARATOR = ' - ';
const ANIMATION_DURATION = 300;
const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const INVALID_DATE = '32/32/2032';
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const DAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const DAYS_MIN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const DATE_FORMAT_REG_EXP = /([YyMmwdE]+)/g;

function isValidDate(date) {
  if (Array.isArray(date)) {
    return date.every(currentDate => isDate_1(currentDate) && currentDate.toString() !== 'Invalid Date');
  }
  return isDate_1(date) && date.toString() !== 'Invalid Date';
}
const getSplittedDateParts = (date) => date.match(DATE_FORMAT_REG_EXP)?.map(item => item.toLowerCase()) || [];
function getCurrentFormatDate(dateFormat, separator = '/') {
  return (date) => {
    if (!date)
      return new Date(INVALID_DATE);
    const formatItems = dateFormat.match(DATE_FORMAT_REG_EXP)?.map(item => item.toLowerCase()) || [];
    const dateItems = date.split(separator).map(item => {
      const formattedItem = item.includes(',') ? item.slice(0, -1) : item;
      return !isNaN(Number(formattedItem)) ? Number(formattedItem) : formattedItem;
    });
    if (formatItems.length !== dateItems.length) {
      return new Date(INVALID_DATE);
    }
    const monthFormat = formatItems.find(item => item.includes('m'));
    const month = monthFormat
      ? monthFormat === 'mm' || monthFormat === 'm'
        ? dateItems[formatItems.indexOf(monthFormat)] - 1
        : (monthFormat === 'mmm' ? MONTHS_SHORT : MONTHS).indexOf(dateItems[formatItems.indexOf(monthFormat)])
      : undefined;
    const dayFormat = formatItems.find(item => item.includes('d'));
    const day = dayFormat ? dateItems[formatItems.indexOf(dayFormat)] : undefined;
    const yearFormat = formatItems.find(item => item.includes('yy'));
    const year = yearFormat ? dateItems[formatItems.indexOf(yearFormat)] : undefined;
    if (year && month !== undefined && day) {
      const formattedYear = yearFormat === 'yy' ? parseInt(`${year >= 50 ? '19' : '20'}` + year, 10) : year;
      return new Date(formattedYear, month, day);
    }
    return new Date(INVALID_DATE);
  };
}
const getFormattedDateString = (date = '', dateFormat, separator = '/') => {
  const formatItems = getSplittedDateParts(dateFormat);
  let prevMargin = 0;
  let isAllMatchedPartsLength = true;
  const formattedInfoParts = formatItems
    .map((item, index) => {
    const nextMargin = prevMargin + item.length;
    const currStringPart = date.substring(prevMargin, nextMargin);
    const isToAddSlash = currStringPart && currStringPart.length === item.length && index !== formatItems.length - 1;
    prevMargin = nextMargin;
    if (currStringPart.length !== item.length) {
      isAllMatchedPartsLength = false;
    }
    return `${currStringPart}${isToAddSlash ? separator : ''}`;
  })
    .filter(Boolean)
    .join('');
  return {
    formattedDate: formattedInfoParts,
    isAllMatchedPartsLength,
  };
};
const getNextCursorPosition = (value, startPos, isAdded, separator = '/') => {
  const nearElement = isAdded ? value[startPos] : value[startPos - 2];
  let nextPosition = startPos;
  if (isAdded) {
    if (nearElement === separator) {
      nextPosition += 1;
    }
    if (value.endsWith(DATES_SEPARATOR)) {
      nextPosition = value.length;
    }
  }
  return nextPosition;
};

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides = ['top', 'right', 'bottom', 'left'];
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};

function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

function getCssDimensions(element) {
  const css = getComputedStyle(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

const topLayerSelectors = [':popover-open', ':modal'];
function isTopLayer(floating) {
  return topLayerSelectors.some(selector => {
    try {
      return floating.matches(selector);
    } catch (e) {
      return false;
    }
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const x = rect.left + scroll.scrollLeft - offsets.x;
  const y = rect.top + scroll.scrollTop - offsets.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow(element);
  if (!isHTMLElement(element) || isTopLayer(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      ...(await getDimensionsFn(data.floating))
    }
  };
};

function isRTL(element) {
  return getComputedStyle(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = shift$1;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = flip$1;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = hide$1;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = arrow$1;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

const getArrowOffset = (staticSide, arrowOffset) => arrowOffset || (['top', 'bottom'].includes(staticSide) ? ARROW_VERTICAL_OFFSET : ARROW_HORIZONTAL_OFFSET);
const attachArrowToElement = (middlewareData, arrowEl, placement, arrowOffset, paddingOnSide) => {
  const { x: arrowX, y: arrowY } = middlewareData.arrow;
  const staticSide = STATIC_SIDES[placement.split('-')[0]];
  const rotationValue = ROTATION_VALUES[staticSide];
  const staticSideValue = (paddingOnSide || 0) - getArrowOffset(staticSide, arrowOffset);
  Object.assign(arrowEl.style, {
    left: arrowX != null ? `${arrowX}px` : '',
    top: arrowY != null ? `${arrowY}px` : '',
    right: '',
    bottom: '',
    [staticSide]: `${staticSideValue}px`,
    transform: `rotate(${rotationValue}deg)`,
  });
};
const computeFloatingUI = ({ referenceEl, floatingEl, arrowEl, configOptions, showStyles, paddingOnSide, }) => {
  if (!referenceEl || !floatingEl)
    return undefined;
  const updatePosition = () => {
    if (arrowEl) {
      Object.assign(floatingEl.style, {
        padding: `${paddingOnSide}px`,
      });
    }
    computePosition(referenceEl, floatingEl, {
      middleware: [
        offset(configOptions?.offset || DEFAULT_OFFSET),
        configOptions?.shouldNotFlipEl ? null : flip(),
        shift({ padding: DEFAULT_OFFSET }),
        arrowEl ? arrow({ element: arrowEl, padding: DEFAULT_OFFSET }) : null,
        hide(),
      ],
      placement: configOptions?.placement || 'top',
      strategy: configOptions?.strategy,
    }).then(({ x, y, middlewareData, placement }) => {
      if (middlewareData.arrow && arrowEl) {
        attachArrowToElement(middlewareData, arrowEl, placement, configOptions?.arrowOffset, paddingOnSide);
      }
      Object.assign(floatingEl.style, {
        left: `${x}px`,
        top: `${y}px`,
        position: configOptions?.strategy || 'absolute',
        ...(configOptions?.zIndex ? { zIndex: configOptions.zIndex } : {}),
        ...(configOptions?.triggerElementWidth ? { width: `${referenceEl.getBoundingClientRect().width}px` } : {}),
        ...(showStyles || DEFAULT_SHOW_STYLES),
        visibility: middlewareData.hide?.referenceHidden ? 'hidden' : 'visible',
      });
      floatingEl.setAttribute('data-placement', placement);
    });
  };
  setTimeout(() => {
    if (configOptions?.onShow) {
      configOptions.onShow();
    }
  }, 0);
  const cleanup = autoUpdate(referenceEl, floatingEl, updatePosition, { elementResize: false });
  return cleanup;
};

const wppDatepickerCss = ".air-datepicker-cell.-year-.-other-decade-,.air-datepicker-cell.-day-.-other-month-{color:var(--adp-color-other-month)}.air-datepicker-cell.-year-.-other-decade-:hover,.air-datepicker-cell.-day-.-other-month-:hover{color:var(--adp-color-other-month-hover)}.-disabled-.-focus-.air-datepicker-cell.-year-.-other-decade-,.-disabled-.-focus-.air-datepicker-cell.-day-.-other-month-{color:var(--adp-color-other-month)}.-selected-.air-datepicker-cell.-year-.-other-decade-,.-selected-.air-datepicker-cell.-day-.-other-month-{color:#fff;background:var(--adp-background-color-selected-other-month)}.-selected-.-focus-.air-datepicker-cell.-year-.-other-decade-,.-selected-.-focus-.air-datepicker-cell.-day-.-other-month-{background:var(--adp-background-color-selected-other-month-focused)}.-in-range-.air-datepicker-cell.-year-.-other-decade-,.-in-range-.air-datepicker-cell.-day-.-other-month-{background-color:var(--adp-background-color-in-range);color:var(--adp-color)}.-in-range-.-focus-.air-datepicker-cell.-year-.-other-decade-,.-in-range-.-focus-.air-datepicker-cell.-day-.-other-month-{background-color:var(--adp-background-color-in-range-focused)}.air-datepicker-cell.-year-.-other-decade-:empty,.air-datepicker-cell.-day-.-other-month-:empty{background:none;border:none}.air-datepicker-cell{border-radius:var(--adp-cell-border-radius);-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;z-index:1}.air-datepicker-cell.-focus-{background:var(--adp-cell-background-color-hover)}.air-datepicker-cell.-current-{color:var(--adp-color-current-date)}.air-datepicker-cell.-current-.-focus-{color:var(--adp-color)}.air-datepicker-cell.-current-.-in-range-{color:var(--adp-color-current-date)}.air-datepicker-cell.-disabled-{cursor:default;color:var(--adp-color-disabled)}.air-datepicker-cell.-disabled-.-focus-{color:var(--adp-color-disabled)}.air-datepicker-cell.-disabled-.-in-range-{color:var(--adp-color-disabled-in-range)}.air-datepicker-cell.-disabled-.-current-.-focus-{color:var(--adp-color-disabled)}.air-datepicker-cell.-in-range-{background:var(--adp-cell-background-color-in-range);border-radius:0}.air-datepicker-cell.-in-range-:hover{background:var(--adp-cell-background-color-in-range-hover)}.air-datepicker-cell.-range-from-{border:1px solid var(--adp-cell-border-color-in-range);background-color:var(--adp-cell-background-color-in-range);border-radius:var(--adp-cell-border-radius) 0 0 var(--adp-cell-border-radius)}.air-datepicker-cell.-range-to-{border:1px solid var(--adp-cell-border-color-in-range);background-color:var(--adp-cell-background-color-in-range);border-radius:0 var(--adp-cell-border-radius) var(--adp-cell-border-radius) 0}.air-datepicker-cell.-range-to-.-range-from-{border-radius:var(--adp-cell-border-radius)}.air-datepicker-cell.-selected-{color:#fff;border:none;background:var(--adp-cell-background-color-selected)}.air-datepicker-cell.-selected-.-current-{color:#fff;background:var(--adp-cell-background-color-selected)}.air-datepicker-cell.-selected-.-focus-{background:var(--adp-cell-background-color-selected-hover)}.air-datepicker-body{-webkit-transition:all var(--adp-transition-duration) var(--adp-transition-ease);transition:all var(--adp-transition-duration) var(--adp-transition-ease)}.air-datepicker-body.-hidden-{display:none}.air-datepicker-body--day-names{display:grid;grid-template-columns:repeat(7, var(--adp-day-cell-width));margin:8px 0 3px}.air-datepicker-body--day-name{color:var(--adp-day-name-color);display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex:1;flex:1;text-align:center;text-transform:uppercase;font-size:.8em}.air-datepicker-body--day-name.-clickable-{cursor:pointer}.air-datepicker-body--day-name.-clickable-:hover{color:var(--adp-day-name-color-hover)}.air-datepicker-body--cells{display:grid}.air-datepicker-body--cells.-days-{grid-template-columns:repeat(7, var(--adp-day-cell-width));grid-auto-rows:var(--adp-day-cell-height)}.air-datepicker-body--cells.-months-{grid-template-columns:repeat(3, 1fr);grid-auto-rows:var(--adp-month-cell-height)}.air-datepicker-body--cells.-years-{grid-template-columns:repeat(4, 1fr);grid-auto-rows:var(--adp-year-cell-height)}.air-datepicker-nav{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;border-bottom:1px solid var(--adp-border-color-inner);min-height:var(--adp-nav-height);padding:var(--adp-padding);-webkit-box-sizing:content-box;box-sizing:content-box}.-only-timepicker- .air-datepicker-nav{display:none}.air-datepicker-nav--title,.air-datepicker-nav--action{display:-ms-flexbox;display:flex;cursor:pointer;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.air-datepicker-nav--action{width:var(--adp-nav-action-size);border-radius:var(--adp-border-radius);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.air-datepicker-nav--action:hover{background:var(--adp-background-color-hover)}.air-datepicker-nav--action:active{background:var(--adp-background-color-active)}.air-datepicker-nav--action.-disabled-{visibility:hidden}.air-datepicker-nav--action svg{width:32px;height:32px}.air-datepicker-nav--action path{fill:none;stroke:var(--adp-nav-arrow-color);stroke-width:2px}.air-datepicker-nav--title{border-radius:var(--adp-border-radius);padding:0 8px}.air-datepicker-nav--title i{font-style:normal;color:var(--adp-nav-color-secondary);margin-left:.3em}.air-datepicker-nav--title:hover{background:var(--adp-background-color-hover)}.air-datepicker-nav--title:active{background:var(--adp-background-color-active)}.air-datepicker-nav--title.-disabled-{cursor:default;background:none}.air-datepicker-buttons{display:grid;grid-auto-columns:1fr;grid-auto-flow:column}.air-datepicker-button{display:-ms-inline-flexbox;display:inline-flex;color:var(--adp-btn-color);border-radius:var(--adp-btn-border-radius);cursor:pointer;height:var(--adp-btn-height);border:none;background:rgba(255,255,255,0)}.air-datepicker-button:hover{color:var(--adp-btn-color-hover);background:var(--adp-btn-background-color-hover)}.air-datepicker-button:focus{color:var(--adp-btn-color-hover);background:var(--adp-btn-background-color-hover);outline:none}.air-datepicker-button:active{background:var(--adp-btn-background-color-active)}.air-datepicker-button span{outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%}.air-datepicker-time{display:grid;grid-template-columns:-webkit-max-content 1fr;grid-template-columns:max-content 1fr;grid-column-gap:12px;-ms-flex-align:center;align-items:center;position:relative;padding:0 var(--adp-time-padding-inner)}.-only-timepicker- .air-datepicker-time{border-top:none}.air-datepicker-time--current{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex:1;flex:1;font-size:14px;text-align:center}.air-datepicker-time--current-colon{margin:0 2px 3px;line-height:1}.air-datepicker-time--current-hours,.air-datepicker-time--current-minutes{line-height:1;font-size:19px;font-family:\"Century Gothic\",CenturyGothic,AppleGothic,sans-serif;position:relative;z-index:1}.air-datepicker-time--current-hours:after,.air-datepicker-time--current-minutes:after{content:\"\";background:var(--adp-background-color-hover);border-radius:var(--adp-border-radius);position:absolute;left:-2px;top:-3px;right:-2px;bottom:-2px;z-index:-1;opacity:0}.air-datepicker-time--current-hours.-focus-:after,.air-datepicker-time--current-minutes.-focus-:after{opacity:1}.air-datepicker-time--current-ampm{text-transform:uppercase;-ms-flex-item-align:end;align-self:flex-end;color:var(--adp-time-day-period-color);margin-left:6px;font-size:11px;margin-bottom:1px}.air-datepicker-time--row{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-size:11px;height:17px;background:-webkit-gradient(linear, left top, right top, from(var(--adp-time-track-color)), to(var(--adp-time-track-color))) left 50%/100% var(--adp-time-track-height) no-repeat;background:linear-gradient(to right, var(--adp-time-track-color), var(--adp-time-track-color)) left 50%/100% var(--adp-time-track-height) no-repeat}.air-datepicker-time--row:first-child{margin-bottom:4px}.air-datepicker-time--row input[type=range]{background:none;cursor:pointer;-ms-flex:1;flex:1;height:100%;width:100%;padding:0;margin:0;-webkit-appearance:none}.air-datepicker-time--row input[type=range]::-webkit-slider-thumb{-webkit-appearance:none}.air-datepicker-time--row input[type=range]::-ms-tooltip{display:none}.air-datepicker-time--row input[type=range]:hover::-webkit-slider-thumb{border-color:var(--adp-time-track-color-hover)}.air-datepicker-time--row input[type=range]:hover::-moz-range-thumb{border-color:var(--adp-time-track-color-hover)}.air-datepicker-time--row input[type=range]:hover::-ms-thumb{border-color:var(--adp-time-track-color-hover)}.air-datepicker-time--row input[type=range]:focus{outline:none}.air-datepicker-time--row input[type=range]:focus::-webkit-slider-thumb{background:var(--adp-cell-background-color-selected);border-color:var(--adp-cell-background-color-selected)}.air-datepicker-time--row input[type=range]:focus::-moz-range-thumb{background:var(--adp-cell-background-color-selected);border-color:var(--adp-cell-background-color-selected)}.air-datepicker-time--row input[type=range]:focus::-ms-thumb{background:var(--adp-cell-background-color-selected);border-color:var(--adp-cell-background-color-selected)}.air-datepicker-time--row input[type=range]::-webkit-slider-thumb{-webkit-box-sizing:border-box;box-sizing:border-box;height:12px;width:12px;border-radius:3px;border:1px solid var(--adp-time-track-color);background:#fff;cursor:pointer;-webkit-transition:background var(--adp-transition-duration);transition:background var(--adp-transition-duration)}.air-datepicker-time--row input[type=range]::-moz-range-thumb{box-sizing:border-box;height:12px;width:12px;border-radius:3px;border:1px solid var(--adp-time-track-color);background:#fff;cursor:pointer;-moz-transition:background var(--adp-transition-duration);transition:background var(--adp-transition-duration)}.air-datepicker-time--row input[type=range]::-ms-thumb{box-sizing:border-box;height:12px;width:12px;border-radius:3px;border:1px solid var(--adp-time-track-color);background:#fff;cursor:pointer;-ms-transition:background var(--adp-transition-duration);transition:background var(--adp-transition-duration)}.air-datepicker-time--row input[type=range]::-webkit-slider-thumb{margin-top:calc(var(--adp-time-thumb-size)/2*-1)}.air-datepicker-time--row input[type=range]::-webkit-slider-runnable-track{border:none;height:var(--adp-time-track-height);cursor:pointer;color:rgba(0,0,0,0);background:rgba(0,0,0,0)}.air-datepicker-time--row input[type=range]::-moz-range-track{border:none;height:var(--adp-time-track-height);cursor:pointer;color:rgba(0,0,0,0);background:rgba(0,0,0,0)}.air-datepicker-time--row input[type=range]::-ms-track{border:none;height:var(--adp-time-track-height);cursor:pointer;color:rgba(0,0,0,0);background:rgba(0,0,0,0)}.air-datepicker-time--row input[type=range]::-ms-fill-lower{background:rgba(0,0,0,0)}.air-datepicker-time--row input[type=range]::-ms-fill-upper{background:rgba(0,0,0,0)}.air-datepicker{--adp-font-family:-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";--adp-font-size:14px;--adp-width:246px;--adp-z-index:100;--adp-padding:4px;--adp-grid-areas:\"nav\" \"body\" \"timepicker\" \"buttons\";--adp-transition-duration:.3s;--adp-transition-ease:ease-out;--adp-transition-offset:8px;--adp-background-color:#fff;--adp-background-color-hover:#f0f0f0;--adp-background-color-active:#eaeaea;--adp-background-color-in-range:rgba(92, 196, 239, .1);--adp-background-color-in-range-focused:rgba(92, 196, 239, .2);--adp-background-color-selected-other-month-focused:#8ad5f4;--adp-background-color-selected-other-month:#a2ddf6;--adp-color:#4a4a4a;--adp-color-secondary:#9c9c9c;--adp-accent-color:#4eb5e6;--adp-color-current-date:var(--adp-accent-color);--adp-color-other-month:#dedede;--adp-color-disabled:#aeaeae;--adp-color-disabled-in-range:#939393;--adp-color-other-month-hover:#c5c5c5;--adp-border-color:#dbdbdb;--adp-border-color-inner:#efefef;--adp-border-radius:4px;--adp-border-color-inline:#d7d7d7;--adp-nav-height:32px;--adp-nav-arrow-color:var(--adp-color-secondary);--adp-nav-action-size:32px;--adp-nav-color-secondary:var(--adp-color-secondary);--adp-day-name-color:#ff9a19;--adp-day-name-color-hover:#8ad5f4;--adp-day-cell-width:1fr;--adp-day-cell-height:32px;--adp-month-cell-height:42px;--adp-year-cell-height:56px;--adp-pointer-size:10px;--adp-poiner-border-radius:2px;--adp-pointer-offset:14px;--adp-cell-border-radius:4px;--adp-cell-background-color-hover:var(--adp-background-color-hover);--adp-cell-background-color-selected:#5cc4ef;--adp-cell-background-color-selected-hover:#45bced;--adp-cell-background-color-in-range:rgba(92, 196, 239, 0.1);--adp-cell-background-color-in-range-hover:rgba(92, 196, 239, 0.2);--adp-cell-border-color-in-range:var(--adp-cell-background-color-selected);--adp-btn-height:32px;--adp-btn-color:var(--adp-accent-color);--adp-btn-color-hover:var(--adp-color);--adp-btn-border-radius:var(--adp-border-radius);--adp-btn-background-color-hover:var(--adp-background-color-hover);--adp-btn-background-color-active:var(--adp-background-color-active);--adp-time-track-height:1px;--adp-time-track-color:#dedede;--adp-time-track-color-hover:#b1b1b1;--adp-time-thumb-size:12px;--adp-time-padding-inner:10px;--adp-time-day-period-color:var(--adp-color-secondary);--adp-mobile-font-size:16px;--adp-mobile-nav-height:40px;--adp-mobile-width:320px;--adp-mobile-day-cell-height:38px;--adp-mobile-month-cell-height:48px;--adp-mobile-year-cell-height:64px}.air-datepicker-overlay{--adp-overlay-background-color:rgba(0, 0, 0, .3);--adp-overlay-transition-duration:.3s;--adp-overlay-transition-ease:ease-out;--adp-overlay-z-index:99}.air-datepicker{background:var(--adp-background-color);border:1px solid var(--adp-border-color);-webkit-box-shadow:0 4px 12px rgba(0,0,0,.15);box-shadow:0 4px 12px rgba(0,0,0,.15);border-radius:var(--adp-border-radius);-webkit-box-sizing:content-box;box-sizing:content-box;display:grid;grid-template-columns:1fr;grid-template-rows:repeat(4, -webkit-max-content);grid-template-rows:repeat(4, max-content);grid-template-areas:var(--adp-grid-areas);font-family:var(--adp-font-family),sans-serif;font-size:var(--adp-font-size);color:var(--adp-color);width:var(--adp-width);position:absolute;-webkit-transition:opacity var(--adp-transition-duration) var(--adp-transition-ease),-webkit-transform var(--adp-transition-duration) var(--adp-transition-ease);transition:opacity var(--adp-transition-duration) var(--adp-transition-ease),-webkit-transform var(--adp-transition-duration) var(--adp-transition-ease);transition:opacity var(--adp-transition-duration) var(--adp-transition-ease),transform var(--adp-transition-duration) var(--adp-transition-ease);transition:opacity var(--adp-transition-duration) var(--adp-transition-ease),transform var(--adp-transition-duration) var(--adp-transition-ease),-webkit-transform var(--adp-transition-duration) var(--adp-transition-ease);z-index:var(--adp-z-index)}.air-datepicker:not(.-custom-position-){opacity:0}.air-datepicker.-from-top-{-webkit-transform:translateY(calc(var(--adp-transition-offset) * -1));transform:translateY(calc(var(--adp-transition-offset) * -1))}.air-datepicker.-from-right-{-webkit-transform:translateX(var(--adp-transition-offset));transform:translateX(var(--adp-transition-offset))}.air-datepicker.-from-bottom-{-webkit-transform:translateY(var(--adp-transition-offset));transform:translateY(var(--adp-transition-offset))}.air-datepicker.-from-left-{-webkit-transform:translateX(calc(var(--adp-transition-offset) * -1));transform:translateX(calc(var(--adp-transition-offset) * -1))}.air-datepicker.-active-:not(.-custom-position-){-webkit-transform:translate(0, 0);transform:translate(0, 0);opacity:1}.air-datepicker.-active-.-custom-position-{-webkit-transition:none;transition:none}.air-datepicker.-inline-{border-color:var(--adp-border-color-inline);-webkit-box-shadow:none;box-shadow:none;position:static;left:auto;right:auto;opacity:1;-webkit-transform:none;transform:none}.air-datepicker.-inline- .air-datepicker--pointer{display:none}.air-datepicker.-is-mobile-{--adp-font-size:var(--adp-mobile-font-size);--adp-day-cell-height:var(--adp-mobile-day-cell-height);--adp-month-cell-height:var(--adp-mobile-month-cell-height);--adp-year-cell-height:var(--adp-mobile-year-cell-height);--adp-nav-height:var(--adp-mobile-nav-height);--adp-nav-action-size:var(--adp-mobile-nav-height);position:fixed;width:var(--adp-mobile-width);border:none}.air-datepicker.-is-mobile- *{-webkit-tap-highlight-color:rgba(0,0,0,0)}.air-datepicker.-is-mobile- .air-datepicker--pointer{display:none}.air-datepicker.-is-mobile-:not(.-custom-position-){-webkit-transform:translate(-50%, calc(-50% + var(--adp-transition-offset)));transform:translate(-50%, calc(-50% + var(--adp-transition-offset)))}.air-datepicker.-is-mobile-.-active-:not(.-custom-position-){-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.air-datepicker.-custom-position-{-webkit-transition:none;transition:none}.air-datepicker-global-container{position:absolute;left:0;top:0}.air-datepicker--pointer{--pointer-half-size:calc(var(--adp-pointer-size) / 2);position:absolute;width:var(--adp-pointer-size);height:var(--adp-pointer-size);z-index:-1}.air-datepicker--pointer:after{content:\"\";position:absolute;background:#fff;border-top:1px solid var(--adp-border-color-inline);border-right:1px solid var(--adp-border-color-inline);border-top-right-radius:var(--adp-poiner-border-radius);width:var(--adp-pointer-size);height:var(--adp-pointer-size);-webkit-box-sizing:border-box;box-sizing:border-box}.-top-left- .air-datepicker--pointer,.-top-center- .air-datepicker--pointer,.-top-right- .air-datepicker--pointer,[data-popper-placement^=top] .air-datepicker--pointer{top:calc(100% - var(--pointer-half-size) + 1px)}.-top-left- .air-datepicker--pointer:after,.-top-center- .air-datepicker--pointer:after,.-top-right- .air-datepicker--pointer:after,[data-popper-placement^=top] .air-datepicker--pointer:after{-webkit-transform:rotate(135deg);transform:rotate(135deg)}.-right-top- .air-datepicker--pointer,.-right-center- .air-datepicker--pointer,.-right-bottom- .air-datepicker--pointer,[data-popper-placement^=right] .air-datepicker--pointer{right:calc(100% - var(--pointer-half-size) + 1px)}.-right-top- .air-datepicker--pointer:after,.-right-center- .air-datepicker--pointer:after,.-right-bottom- .air-datepicker--pointer:after,[data-popper-placement^=right] .air-datepicker--pointer:after{-webkit-transform:rotate(225deg);transform:rotate(225deg)}.-bottom-left- .air-datepicker--pointer,.-bottom-center- .air-datepicker--pointer,.-bottom-right- .air-datepicker--pointer,[data-popper-placement^=bottom] .air-datepicker--pointer{bottom:calc(100% - var(--pointer-half-size) + 1px)}.-bottom-left- .air-datepicker--pointer:after,.-bottom-center- .air-datepicker--pointer:after,.-bottom-right- .air-datepicker--pointer:after,[data-popper-placement^=bottom] .air-datepicker--pointer:after{-webkit-transform:rotate(315deg);transform:rotate(315deg)}.-left-top- .air-datepicker--pointer,.-left-center- .air-datepicker--pointer,.-left-bottom- .air-datepicker--pointer,[data-popper-placement^=left] .air-datepicker--pointer{left:calc(100% - var(--pointer-half-size) + 1px)}.-left-top- .air-datepicker--pointer:after,.-left-center- .air-datepicker--pointer:after,.-left-bottom- .air-datepicker--pointer:after,[data-popper-placement^=left] .air-datepicker--pointer:after{-webkit-transform:rotate(45deg);transform:rotate(45deg)}.-top-left- .air-datepicker--pointer,.-bottom-left- .air-datepicker--pointer{left:var(--adp-pointer-offset)}.-top-right- .air-datepicker--pointer,.-bottom-right- .air-datepicker--pointer{right:var(--adp-pointer-offset)}.-top-center- .air-datepicker--pointer,.-bottom-center- .air-datepicker--pointer{left:calc(50% - var(--adp-pointer-size)/2)}.-left-top- .air-datepicker--pointer,.-right-top- .air-datepicker--pointer{top:var(--adp-pointer-offset)}.-left-bottom- .air-datepicker--pointer,.-right-bottom- .air-datepicker--pointer{bottom:var(--adp-pointer-offset)}.-left-center- .air-datepicker--pointer,.-right-center- .air-datepicker--pointer{top:calc(50% - var(--adp-pointer-size)/2)}.air-datepicker--navigation{grid-area:nav}.air-datepicker--content{-webkit-box-sizing:content-box;box-sizing:content-box;padding:var(--adp-padding);grid-area:body}.-only-timepicker- .air-datepicker--content{display:none}.air-datepicker--time{grid-area:timepicker}.air-datepicker--buttons{grid-area:buttons}.air-datepicker--buttons,.air-datepicker--time{padding:var(--adp-padding);border-top:1px solid var(--adp-border-color-inner)}.air-datepicker-overlay{position:fixed;background:var(--adp-overlay-background-color);left:0;top:0;width:0;height:0;opacity:0;-webkit-transition:opacity var(--adp-overlay-transition-duration) var(--adp-overlay-transition-ease),left 0s,height 0s,width 0s;transition:opacity var(--adp-overlay-transition-duration) var(--adp-overlay-transition-ease),left 0s,height 0s,width 0s;-webkit-transition-delay:0s,var(--adp-overlay-transition-duration),var(--adp-overlay-transition-duration),var(--adp-overlay-transition-duration);transition-delay:0s,var(--adp-overlay-transition-duration),var(--adp-overlay-transition-duration),var(--adp-overlay-transition-duration);z-index:var(--adp-overlay-z-index)}.air-datepicker-overlay.-active-{opacity:1;width:100%;height:100%;-webkit-transition:opacity var(--adp-overlay-transition-duration) var(--adp-overlay-transition-ease),height 0s,width 0s;transition:opacity var(--adp-overlay-transition-duration) var(--adp-overlay-transition-ease),height 0s,width 0s}.typography-5xl-display{font-size:var(--wpp-typography-5xl-display-font-size, 48px);font-family:var(--wpp-typography-5xl-display-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-5xl-display-line-height, 62px);letter-spacing:var(--wpp-typography-5xl-display-letter-spacing, 0);text-transform:var(--wpp-typography-5xl-display-text-transform, initial);color:var(--wpp-typography-5xl-display-color, var(--wpp-text-color));font-weight:var(--wpp-typography-5xl-display-font-weight, 600);font-style:var(--wpp-typography-5xl-display-font-style, normal)}.typography-4xl-display{font-size:var(--wpp-typography-4xl-display-font-size, 36px);font-family:var(--wpp-typography-4xl-display-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-4xl-display-line-height, 48px);letter-spacing:var(--wpp-typography-4xl-display-letter-spacing, 0);text-transform:var(--wpp-typography-4xl-display-text-transform, initial);color:var(--wpp-typography-4xl-display-color, var(--wpp-text-color));font-weight:var(--wpp-typography-4xl-display-font-weight, 600);font-style:var(--wpp-typography-4xl-display-font-style, normal)}.typography-3xl-heading{font-size:var(--wpp-typography-3xl-heading-font-size, 28px);font-family:var(--wpp-typography-3xl-heading-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-3xl-heading-line-height, 40px);letter-spacing:var(--wpp-typography-3xl-heading-letter-spacing, 0);text-transform:var(--wpp-typography-3xl-heading-text-transform, initial);color:var(--wpp-typography-3xl-heading-color, var(--wpp-text-color));font-weight:var(--wpp-typography-3xl-heading-font-weight, 600);font-style:var(--wpp-typography-3xl-heading-font-style, normal)}.typography-2xl-heading{font-size:var(--wpp-typography-2xl-heading-font-size, 24px);font-family:var(--wpp-typography-2xl-heading-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-2xl-heading-line-height, 32px);letter-spacing:var(--wpp-typography-2xl-heading-letter-spacing, 0);text-transform:var(--wpp-typography-2xl-heading-text-transform, initial);color:var(--wpp-typography-2xl-heading-color, var(--wpp-text-color));font-weight:var(--wpp-typography-2xl-heading-font-weight, 600);font-style:var(--wpp-typography-2xl-heading-font-style, normal)}.typography-xl-heading{font-size:var(--wpp-typography-xl-heading-font-size, 20px);font-family:var(--wpp-typography-xl-heading-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xl-heading-line-height, 32px);letter-spacing:var(--wpp-typography-xl-heading-letter-spacing, 0);text-transform:var(--wpp-typography-xl-heading-text-transform, initial);color:var(--wpp-typography-xl-heading-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xl-heading-font-weight, 600);font-style:var(--wpp-typography-xl-heading-font-style, normal)}.typography-l-strong{font-size:var(--wpp-typography-l-body-font-size, 18px);font-family:var(--wpp-typography-l-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-l-body-line-height, 28px);letter-spacing:var(--wpp-typography-l-body-letter-spacing, 0);text-transform:var(--wpp-typography-l-body-text-transform, initial);color:var(--wpp-typography-l-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-l-strong-font-weight, 600);font-style:var(--wpp-typography-l-strong-font-style, normal)}.typography-l-midi{font-size:var(--wpp-typography-l-body-font-size, 18px);font-family:var(--wpp-typography-l-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-l-body-line-height, 28px);letter-spacing:var(--wpp-typography-l-body-letter-spacing, 0);text-transform:var(--wpp-typography-l-body-text-transform, initial);color:var(--wpp-typography-l-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-l-midi-font-weight, 500);font-style:var(--wpp-typography-l-midi-font-style, normal)}.typography-l-body{font-size:var(--wpp-typography-l-body-font-size, 18px);font-family:var(--wpp-typography-l-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-l-body-line-height, 28px);letter-spacing:var(--wpp-typography-l-body-letter-spacing, 0);text-transform:var(--wpp-typography-l-body-text-transform, initial);color:var(--wpp-typography-l-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-l-body-font-weight, 400);font-style:var(--wpp-typography-l-body-font-style, normal)}.typography-m-strong{font-size:var(--wpp-typography-m-body-font-size, 16px);font-family:var(--wpp-typography-m-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-m-body-line-height, 24px);letter-spacing:var(--wpp-typography-m-body-letter-spacing, 0);text-transform:var(--wpp-typography-m-body-text-transform, initial);color:var(--wpp-typography-m-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-m-strong-font-weight, 600);font-style:var(--wpp-typography-m-strong-font-style, normal)}.typography-m-midi{font-size:var(--wpp-typography-m-body-font-size, 16px);font-family:var(--wpp-typography-m-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-m-body-line-height, 24px);letter-spacing:var(--wpp-typography-m-body-letter-spacing, 0);text-transform:var(--wpp-typography-m-body-text-transform, initial);color:var(--wpp-typography-m-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-m-midi-font-weight, 500);font-style:var(--wpp-typography-m-midi-font-style, normal)}.typography-m-body{font-size:var(--wpp-typography-m-body-font-size, 16px);font-family:var(--wpp-typography-m-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-m-body-line-height, 24px);letter-spacing:var(--wpp-typography-m-body-letter-spacing, 0);text-transform:var(--wpp-typography-m-body-text-transform, initial);color:var(--wpp-typography-m-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-m-body-font-weight, 400);font-style:var(--wpp-typography-m-body-font-style, normal)}.typography-s-strong{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-strong-font-weight, 600);font-style:var(--wpp-typography-s-strong-font-style, normal)}.typography-s-midi{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-midi-font-weight, 500);font-style:var(--wpp-typography-s-midi-font-style, normal)}.typography-s-body{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal)}.typography-xs-strong{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-strong-font-weight, 600);font-style:var(--wpp-typography-xs-strong-font-style, normal)}.typography-xs-midi{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-midi-font-weight, 500);font-style:var(--wpp-typography-xs-midi-font-style, normal)}.typography-xs-body{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-body-font-weight, 400);font-style:var(--wpp-typography-xs-body-font-style, normal)}.typography-2xs-strong{font-size:var(--wpp-typography-2xs-strong-font-size, 10px);font-family:var(--wpp-typography-2xs-strong-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-2xs-strong-line-height, 20px);letter-spacing:var(--wpp-typography-2xs-strong-letter-spacing, 0.5px);text-transform:var(--wpp-typography-2xs-strong-text-transform, uppercase);color:var(--wpp-typography-2xs-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-2xs-strong-font-weight, 700);font-style:var(--wpp-typography-2xs-strong-font-style, normal)}:host{--datepicker-button-padding:var(--wpp-datepicker-button-padding, 1px 6px);--datepicker-min-width:var(--wpp-datepicker-min-width, 240px);--datepicker-padding:var(--wpp-datepicker-padding, 8px);--datepicker-box-shadow:var(--wpp-datepicker-box-shadow, var(--wpp-box-shadow-xs));--datepicker-current-date-color:var(--wpp-datepicker-current-date-color, var(--wpp-brand-color));--datepicker-current-date-color-active:var(--wpp-datepicker-current-date-color-active, var(--wpp-grey-color-000));--datepicker-cell-color-selected:var(--wpp-datepicker-cell-color-selected, var(--wpp-brand-color));--datepicker-color-active:var(--wpp-datepicker-color-active, var(--wpp-brand-color-active));--datepicker-color-hover:var(--wpp-datepicker-color-hover, var(--wpp-brand-color-hover));--datepicker-bg-color:var(--wpp-datepicker-bg-color, var(--wpp-grey-color-000));--datepicker-cell-bg-color-hover:var(--wpp-datepicker-cell-bg-color-hover, var(--wpp-grey-color-200));--datepicker-cell-bg-color-active:var(--wpp-datepicker-cell-bg-color-active, var(--wpp-grey-color-300));--datepicker-border-width:var(--wpp-datepicker-border-width, 1px);--datepicker-border-style:var(--wpp-datepicker-border-style, solid);--datepicker-border-color:var(--wpp-datepicker-border-color, transparent);--datepicker-border-radius:var(--wpp-datepicker-border-radius, var(--wpp-border-radius-m));--datepicker-z-index:var(--wpp-datepicker-z-index, 1000);--datepicker-buttons-height:var(--wpp-datepicker-buttons-height, 48px);--datepicker-title-margin:var(--wpp-datepicker-title-margin, 0 0 0 4px);--datepicker-label-margin:var(--wpp-datepicker-label-margin, 0 0 8px 0);--datepicker-cancel-button-color-disabled:var(\n    --wpp-datepicker-cancel-button-color-disabled,\n    var(--wpp-grey-color-500)\n  );--datepicker-cancel-button-color-active:var(--wpp-datepicker-cancel-button-color-active, var(--wpp-grey-color-900));--datepicker-month-year-margin:var(--wpp-datepicker-month-year-margin, 2px);--datepicker-year-height:var(--wpp-datepicker-year-height, 32px);--datepicker-close-icon-color:var(--wpp-datepicker-close-icon-color, var(--wpp-icon-color));--datepicker-close-icon-color-hover:var(--wpp-datepicker-close-icon-color-hover, var(--wpp-icon-color-hover));--datepicker-close-icon-color-active:var(--wpp-datepicker-close-icon-color-active, var(--wpp-icon-color-active));--datepicker-close-icon-color-disabled:var(\n    --wpp-datepicker-close-icon-color-disabled,\n    var(--wpp-icon-color-disabled)\n  );--datepicker-calendar-icon-color:var(--wpp-datepicker-calendar-icon-color, var(--wpp-icon-color));--datepicker-calendar-icon-color-disabled:var(\n    --wpp-datepicker-calendar-icon-color-disabled,\n    var(--wpp-icon-color-disabled)\n  );--datepicker-header-color:var(--wpp-datepicker-header-color, var(--wpp-grey-color-900));--datepicker-month-color:var(--wpp-datepicker-month-color, var(--wpp-grey-color-1000));--datepicker-buttons-margin:var(--wpp-datepicker-buttons-margin, 0 0 0 4px);--datepicker-day-in-range-border-color:var(--wpp-datepicker-day-in-range-border-color, var(--wpp-grey-color-300));--datepicker-day-color:var(--wpp-datepicker-day-color, var(--wpp-grey-color-800));--datepicker-year-color:var(--wpp-datepicker-year-color, var(--wpp-grey-color-1000));--datepicker-title-color:var(--wpp-datepicker-title-color, var(--wpp-grey-color-900));--datepicker-active-date-color:var(--wpp-datepicker-active-date-color, var(--wpp-grey-color-000));--datepicker-years-range-color:var(--wpp-datepicker-years-range-color, var(--wpp-grey-color-1000));--datepicker-day-active-color:var(--wpp-datepicker-day-active-color, var(--wpp-grey-color-000));--datepicker-single-container-width:var(--wpp-datepicker-container-width, 160px);--datepicker-range-container-width:var(--wpp-datepicker-container-width, 250px);--datepicker-inline-message-margin:var(--wpp-datepicker-inline-message-margin, 4px 0 0 0);--datepicker-range-bg-color:var(--wpp-datepicker-range-bg-color, var(--wpp-grey-color-200));--datepicker-range-bg-color-hover:var(--wpp-datepicker-range-bg-color-hover, var(--wpp-grey-color-300));--datepicker-range-bg-color-active:var(--wpp-datepicker-range-bg-color-active, var(--wpp-grey-color-400));--datepicker-range-border-color:var(--wpp-datepicker-range-border-color, none);--datepicker-input-border-radius:var(--wpp-datepicker-input-border-radius, var(--wpp-border-radius-m));--datepicker-input-height-m:var(--wpp-datepicker-input-m, 40px);--datepicker-input-height-s:var(--wpp-datepicker-input-s, 32px);--datepicker-input-border-color:var(--wpp-datepicker-input-border-color, var(--wpp-grey-color-600));--datepicker-input-bg-color-hover:var(--wpp-datepicker-input-bg-color-hover, var(--wpp-grey-color-200));--datepicker-input-bg-color-disabled:var(--wpp-datepicker-input-bg-color-disabled, var(--wpp-grey-color-100));--datepicker-input-text-color-disabled:var(\n    --wpp-datepicker-input-text-color-disabled,\n    var(--wpp-text-color-disabled)\n  );--datepicker-input-border-color-hover:var(--wpp-datepicker-input-border-color-hover, var(--wpp-grey-color-700));--datepicker-input-border-color-active:var(--wpp-datepicker-input-border-color-active, var(--wpp-grey-color-800));--datepicker-input-border-color-disabled:var(\n    --wpp-datepicker-input-border-color-disabled,\n    var(--wpp-grey-color-400)\n  );--datepicker-input-first-border-color-focus:var(\n    --wpp-datepicker-input-first-border-color-focus,\n    var(--wpp-grey-color-000)\n  );--datepicker-input-second-border-color-focus:var(\n    --wpp-datepicker-input-second-border-color-focus,\n    var(--wpp-brand-color)\n  );--datepicker-input-padding-m:var(--wpp-datepicker-input-padding-m, 10px 30px 10px 38px);--datepicker-input-padding-s:var(--wpp-datepicker-input-padding-s, 5px 30px 5px 38px);width:-webkit-max-content;width:-moz-max-content;width:max-content}:host .label{margin:var(--datepicker-label-margin)}:host .air-datepicker{--adp-color-current-date:var(--datepicker-current-date-color);--adp-cell-background-color-selected:var(--datepicker-cell-color-selected);--adp-cell-background-color-selected-hover:var(--datepicker-color-hover);--adp-background-color:var(--datepicker-bg-color);--adp-background-color-hover:var(--datepicker-cell-bg-color-hover);--adp-border-color-inline:var(--datepicker-border-color);--adp-background-color-selected-other-month:var(--datepicker-current-date-color);--adp-background-color-selected-other-month-focused:var(--datepicker-color-hover);--adp-cell-background-color-in-range:var(--datepicker-range-bg-color);--adp-cell-background-color-in-range-hover:var(--datepicker-range-bg-color-hover);--adp-cell-border-color-in-range:var(--datepicker-range-border-color);--adp-z-index:var(--datepicker-z-index);--adp-background-color-in-range:var(--datepicker-range-bg-color);--adp-padding:var(--datepicker-padding) 0;--adp-color:var(--datepicker-day-color);--adp-color-other-month:var(--datepicker-cancel-button-color-disabled);padding:0 8px;border:0;border-radius:var(--datepicker-border-radius);-webkit-box-shadow:var(--wpp-box-shadow-m);box-shadow:var(--wpp-box-shadow-m)}:host .air-datepicker.-inline-{-webkit-box-shadow:var(--wpp-box-shadow-m);box-shadow:var(--wpp-box-shadow-m)}:host .air-datepicker .air-datepicker-cell.-disabled-{cursor:not-allowed}:host .air-datepicker .air-datepicker-cell.-disabled-.-month-,:host .air-datepicker .air-datepicker-cell.-disabled-.-year-,:host .air-datepicker .air-datepicker-cell.-disabled-.-day-{color:var(--datepicker-input-text-color-disabled)}:host .air-datepicker .air-datepicker-cell.-disabled-.-focus-{background-color:initial}:host .air-datepicker .air-datepicker-cell.-disabled-.-focus-:hover{background-color:initial}:host .air-datepicker .air-datepicker-cell.-other-decade-.-year-.-focus-:hover{background-color:var(--adp-cell-background-color-in-range-hover)}:host .air-datepicker .air-datepicker-cell.-year-.-other-decade-.-selected-{color:var(--datepicker-current-date-color-active);background-color:var(--datepicker-cell-color-selected)}:host .air-datepicker .air-datepicker-cell.-year-.-other-decade-.-selected-.-focus-{background-color:var(--adp-cell-background-color-selected-hover)}:host .air-datepicker .air-datepicker-cell.-year-.-other-decade-.-selected-:active{background-color:var(--datepicker-color-active)}:host .air-datepicker--pointer{display:none}:host .air-datepicker-body.-days-{margin-top:-4px}:host .air-datepicker-cell.-day-{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal);margin-top:4px;color:var(--datepicker-day-color)}:host .air-datepicker-cell.-day-:active{color:var(--datepicker-day-active-color);background-color:var(--datepicker-cell-bg-color-active)}:host .air-datepicker-cell.-day-.-disabled-{color:var(--datepicker-cancel-button-color-disabled)}:host .air-datepicker-cell.-day-.-in-range-{border-top:1px solid var(--datepicker-day-in-range-border-color);border-bottom:1px solid var(--datepicker-day-in-range-border-color)}:host .air-datepicker-cell.-day-.-in-range-:active{background-color:var(--datepicker-range-bg-color-active)}:host .air-datepicker-cell:active{background-color:var(--datepicker-cell-bg-color-active)}:host .air-datepicker-cell.-selected-{color:var(--datepicker-current-date-color-active)}:host .air-datepicker-cell.-selected-:active{background-color:var(--datepicker-color-active)}:host .air-datepicker-cell.-month-{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal);margin:var(--datepicker-month-year-margin);color:var(--datepicker-month-color)}:host .air-datepicker-cell.-month-.-selected-{color:var(--datepicker-current-date-color-active)}:host .air-datepicker-cell.-month-.-selected-:active{background-color:var(--datepicker-color-active)}:host .air-datepicker-cell.-year-{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal);height:var(--datepicker-year-height);margin:var(--datepicker-month-year-margin);color:var(--datepicker-year-color)}:host .air-datepicker-cell.-year-.-selected-{color:var(--datepicker-current-date-color-active)}:host .air-datepicker-cell.-year-.-selected-:active{background-color:var(--datepicker-color-active)}:host .air-datepicker-cell.-current-{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-strong-font-weight, 600);font-style:var(--wpp-typography-s-strong-font-style, normal);color:var(--datepicker-current-date-color)}:host .air-datepicker-cell.-current-.-focus-{color:var(--datepicker-color-hover)}:host .air-datepicker-cell.-current-:active{color:var(--datepicker-color-active)}:host .air-datepicker-cell.-current-.-selected-{color:var(--datepicker-current-date-color-active)}:host .air-datepicker-cell.-current-.-selected-:active{color:var(--datepicker-current-date-color-active);background-color:var(--datepicker-color-active)}:host .air-datepicker-body--day-name{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-strong-font-weight, 600);font-style:var(--wpp-typography-xs-strong-font-style, normal);color:var(--datepicker-month-color)}:host .air-datepicker-nav--title{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-strong-font-weight, 600);font-style:var(--wpp-typography-s-strong-font-style, normal);color:var(--datepicker-title-color)}:host .air-datepicker-nav--title .datepicker-header{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-strong-font-weight, 600);font-style:var(--wpp-typography-s-strong-font-style, normal);margin:0;color:var(--datepicker-header-color)}:host .air-datepicker-nav--title .header-year{margin:var(--datepicker-title-margin)}:host .air-datepicker--buttons{position:relative;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-sizing:border-box;box-sizing:border-box;height:var(--datepicker-buttons-height);border-top:none}:host .air-datepicker--buttons::before{position:absolute;top:0;right:0;left:0;border-top:1px solid var(--wpp-grey-color-300);content:\"\"}:host .air-datepicker-buttons{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}:host .air-datepicker-buttons .air-datepicker-button{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-strong-font-weight, 600);font-style:var(--wpp-typography-s-strong-font-style, normal)}:host .air-datepicker-buttons .button-apply{margin:var(--datepicker-buttons-margin) !important;padding:var(--datepicker-button-padding) !important;color:var(--wpp-brand-color)}:host .air-datepicker-buttons .button-apply.disabled{color:var(--datepicker-cancel-button-color-disabled);pointer-events:none}:host .air-datepicker-buttons .button-apply:hover{color:var(--wpp-brand-color-hover)}:host .air-datepicker-buttons .button-apply:active{color:var(--wpp-brand-color-active)}:host .air-datepicker-buttons .button-clear{padding:var(--datepicker-button-padding) !important;color:var(--datepicker-cancel-button-color-active)}:host .air-datepicker-buttons .button-clear.disabled{color:var(--datepicker-cancel-button-color-disabled);pointer-events:none}:host .air-datepicker-nav--action:hover{background-color:transparent}:host .nav-icon{color:var(--datepicker-close-icon-color)}:host .nav-icon:hover{color:var(--datepicker-close-icon-color-hover)}:host .nav-icon:active{color:var(--datepicker-close-icon-color-active)}:host .prev-icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}:host .air-datepicker-body--cells.-years-{-ms-flex-align:center;align-items:center}:host .years{margin:0;color:var(--datepicker-years-range-color);font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal)}:host .inline-message{margin:var(--datepicker-inline-message-margin)}:host.range-selected.with-presets .air-datepicker .air-datepicker--buttons::before{left:-8px}:host .wpp-portal{min-width:var(--datepicker-min-width);position:fixed;visibility:hidden}:host .wpp-portal .air-datepicker{position:relative;left:0 !important;top:0 !important}:host .wpp-portal .air-datepicker .outside-current-view{border-top:none !important;border-bottom:none !important}:host .wpp-portal.with-presets{-webkit-box-shadow:var(--wpp-box-shadow-m);box-shadow:var(--wpp-box-shadow-m);border-radius:var(--datepicker-border-radius);overflow:hidden}:host .wpp-portal.with-presets .air-datepicker{border-radius:0;-webkit-box-shadow:none;box-shadow:none}:host .wpp-portal.with-presets .presets-container{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between;min-width:120px;padding:var(--datepicker-padding);padding-right:0;padding-bottom:0;background-color:var(--datepicker-bg-color)}:host .wpp-portal.with-presets .presets-container .presets-list{padding-right:var(--datepicker-padding)}:host .wpp-portal.with-presets .presets-container .presets-list .presets-item{width:100%;margin-bottom:4px}:host .wpp-portal.with-presets .presets-container .presets-list .presets-item:last-child{margin-bottom:0}:host .wpp-portal.with-presets .presets-container .presets-list .presets-item::part(item){width:100%}:host .wpp-portal.with-presets .presets-container::before{position:absolute;top:var(--datepicker-padding);right:0;bottom:var(--datepicker-buttons-height);border-right:1px solid var(--wpp-grey-color-300);content:\"\"}:host .wpp-portal.with-presets .presets-container .presets-footer{position:relative;width:100%;height:var(--datepicker-buttons-height)}:host .wpp-portal.with-presets .presets-container .presets-footer::before{position:absolute;top:0;right:0;left:0;border-top:1px solid var(--wpp-grey-color-300);content:\"\"}:host .wpp-portal.with-presets.show-portal{-webkit-animation:show-portal 0.3s ease-out forwards;animation:show-portal 0.3s ease-out forwards}@-webkit-keyframes show-portal{0%{-webkit-transform:translateY(8px);transform:translateY(8px);opacity:0}100%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}@keyframes show-portal{0%{-webkit-transform:translateY(8px);transform:translateY(8px);opacity:0}100%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}:host .wpp-portal.with-presets.hide-portal{-webkit-animation:hide-portal 0.3s ease-out forwards;animation:hide-portal 0.3s ease-out forwards;pointer-events:none}@-webkit-keyframes hide-portal{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}100%{-webkit-transform:translateY(8px);transform:translateY(8px);opacity:0}}@keyframes hide-portal{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}100%{-webkit-transform:translateY(8px);transform:translateY(8px);opacity:0}}:host .wpp-portal.range-selected{--wpp-datepicker-range-bg-color:var(--wpp-primary-color-100);--wpp-datepicker-day-in-range-border-color:var(--wpp-primary-color-100)}:host .wpp-portal.range-selected .air-datepicker{--adp-cell-background-color-in-range:var(--wpp-primary-color-100)}:host .wpp-portal.static-portal{position:relative;visibility:visible}:host .wpp-portal.static-portal.with-presets{display:-ms-flexbox;display:flex}:host .wpp-portal.static-portal.with-presets .air-datepicker .air-datepicker--buttons::before{left:-8px}:host #container{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-direction:column;flex-direction:column;position:relative}:host #container.single-datepicker.has-default-format:not(.static-datepicker){width:var(--datepicker-single-container-width)}:host #container.range-datepicker,:host #container.single-datepicker{width:var(--datepicker-range-container-width)}:host #container.static-datepicker{width:var(--datepicker-range-container-width)}:host #container.static-datepicker .calendar-icon,:host #container.static-datepicker .cross-icon{top:14px}:host #container.static-datepicker #datepicker{margin-top:4px}:host #container.static-datepicker.with-presets{width:auto}:host #datepicker{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal);width:100%;display:-ms-inline-flexbox;display:inline-flex;padding:var(--datepicker-input-padding-m);height:var(--datepicker-input-height-m);border:1px solid var(--datepicker-input-border-color);border-radius:var(--datepicker-input-border-radius);-webkit-box-sizing:border-box;box-sizing:border-box;outline:none}:host #datepicker.tab-focus{border-radius:\"\";outline:none;-webkit-box-shadow:0 0 0 1px var(--datepicker-input-first-border-color-focus), 0 0 0 3px var(--datepicker-input-second-border-color-focus);box-shadow:0 0 0 1px var(--datepicker-input-first-border-color-focus), 0 0 0 3px var(--datepicker-input-second-border-color-focus)}:host #datepicker:focus{border-color:var(--datepicker-input-border-color-active)}:host #datepicker:hover{background-color:var(--datepicker-input-bg-color-hover);border-color:var(--datepicker-input-border-color-hover)}:host #datepicker:disabled{color:var(--datepicker-input-text-color-disabled);background:var(--datepicker-input-bg-color-disabled);border-color:var(--datepicker-input-border-color-disabled)}:host #datepicker:disabled::-webkit-input-placeholder{color:var(--datepicker-input-text-color-disabled)}:host #datepicker:disabled::-moz-placeholder{color:var(--datepicker-input-text-color-disabled)}:host #datepicker:disabled:-ms-input-placeholder{color:var(--datepicker-input-text-color-disabled)}:host #datepicker:disabled::-ms-input-placeholder{color:var(--datepicker-input-text-color-disabled)}:host #datepicker:disabled::placeholder{color:var(--datepicker-input-text-color-disabled)}:host #datepicker[type=number]{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}:host #datepicker.size-s{height:var(--datepicker-input-height-s);padding:var(--datepicker-input-padding-s)}:host #datepicker.warning,:host #datepicker.warning:hover{border:var(--datepicker-border-width) var(--datepicker-border-style) var(--wpp-warning-color-400)}:host #datepicker.warning.tab-focus{border-radius:\"\";outline:none;-webkit-box-shadow:0 0 0 1px var(--wpp-grey-color-000), 0 0 0 3px var(--wpp-warning-color-400);box-shadow:0 0 0 1px var(--wpp-grey-color-000), 0 0 0 3px var(--wpp-warning-color-400)}:host #datepicker.error,:host #datepicker.error:hover{border:var(--datepicker-border-width) var(--datepicker-border-style) var(--wpp-danger-color-400)}:host #datepicker.error.tab-focus{border-radius:\"\";outline:none;-webkit-box-shadow:0 0 0 1px var(--wpp-grey-color-000), 0 0 0 3px var(--wpp-danger-color-400);box-shadow:0 0 0 1px var(--wpp-grey-color-000), 0 0 0 3px var(--wpp-danger-color-400)}:host .cross-icon{color:var(--datepicker-close-icon-color);position:absolute;right:10px;top:10px;cursor:pointer}:host .cross-icon.disabled{pointer-events:none;color:var(--datepicker-close-icon-color-disabled)}:host .cross-icon:hover{color:var(--datepicker-close-icon-color-hover)}:host .cross-icon:active{color:var(--datepicker-close-icon-color-active)}:host .cross-icon.size-s{top:6px}:host .calendar-icon{position:absolute;left:10px;top:10px}:host .calendar-icon.size-s{top:6px}:host(.disabled){cursor:not-allowed}:host(.disabled) #datepicker{pointer-events:none}:host(.disabled) .calendar-icon{color:var(--datepicker-calendar-icon-color-disabled)}";

const WppDatepicker$1 = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement$1 {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.wppChange = createEvent(this, "wppChange", 1);
    this.wppBlur = createEvent(this, "wppBlur", 1);
    this.wppFocus = createEvent(this, "wppFocus", 1);
    this.wppDateClear = createEvent(this, "wppDateClear", 1);
    this.isApplyButtonClicked = false;
    this.hasClickedPreset = false;
    this.isStringDateValid = (stringDateValue) => {
      const formatSeparator = this.getDateFormatSeparator(this.locale.dateFormat);
      const [day, month, year] = stringDateValue.split(formatSeparator);
      return day.length === 2 && month.length === 2 && year.length === 4;
    };
    this.setInitialDate = () => {
      if (this.value === '' || isEqual_1(this.value, [])) {
        this.clearDatePicker();
        return;
      }
      if (!this.value)
        return;
      const formatDate = getCurrentFormatDate(this.getDateFormat(), this.getDateFormatSeparator(this.getDateFormat()));
      if (this.range) {
        const [startDate, endDate] = this.value;
        if (!startDate || !endDate)
          return;
        if (isValidDate([formatDate(startDate), formatDate(endDate)])) {
          //@ts-ignore Due to outdated air-datepicker.d.ts
          this.datePickerInstance.selectDate([formatDate(startDate), formatDate(endDate)]);
          this.lastValidDate = this.value;
          this.lastAppliedDate = this.value;
        }
        return;
      }
      if (!Array.isArray(this.value)) {
        this.lastValidDate = this.value;
        const formattedDate = formatDate(this.value);
        this.datePickerInstance.selectDate([formattedDate]);
      }
    };
    this.setMinMaxDate = () => {
      const formatDate = getCurrentFormatDate(this.getDateFormat(), this.getDateFormatSeparator(this.getDateFormat()));
      if (this.maxDate) {
        this.datePickerInstance.update({
          maxDate: formatDate(this.maxDate),
        });
      }
      if (this.minDate) {
        this.datePickerInstance.update({
          minDate: formatDate(this.minDate),
        });
      }
      if (this.range) {
        if (this.lastAppliedDate.length < 2)
          return;
        this.clearIfDateNotInInterval(formatDate(this.lastAppliedDate[0]), formatDate);
        this.clearIfDateNotInInterval(formatDate(this.lastAppliedDate[1]), formatDate);
      }
      else {
        if (!this.lastValidDate)
          return;
        this.clearIfDateNotInInterval(formatDate(this.lastValidDate), formatDate);
      }
    };
    this.clearIfDateNotInInterval = (dateValue, formatDate) => {
      if (formatDate(this.minDate || '') > dateValue || formatDate(this.maxDate || '') < dateValue) {
        this.clearDatePicker();
      }
    };
    this.hasPresets = () => this.range && this.presets.length > 0;
    this.getDatepickerView = () => (this.range ? 'days' : this.view);
    this.getDateFormatSeparator = (dateFormat) => {
      const match = dateFormat.match(DATE_FORMAT_SEPARATOR_PATTERN);
      return match ? match[0] : '/';
    };
    this.isDefaultDateFormatSeparator = (separator) => ['/', '.'].includes(separator);
    this.isDefaultDateFormat = () => {
      const baseFormat = ['dd', 'MM', 'yyyy'].sort();
      const separator = this.getDateFormatSeparator(this.locale.dateFormat);
      if (this.isDefaultDateFormatSeparator(separator)) {
        const separatedDate = this.locale.dateFormat.split(separator).sort();
        return JSON.stringify(baseFormat) === JSON.stringify(separatedDate);
      }
      return false;
    };
    this.getDateFormat = () => {
      if (this.range) {
        return this.isDefaultDateFormat() ? this.locale.dateFormat : DATE_FORMAT.DAY_MONTH_YEAR;
      }
      return this.locale.dateFormat;
    };
    this.createDateInstance = () => {
      if (!this.inputRef)
        return;
      const buttonApply = {
        content: 'Apply',
        className: 'disabled button-apply',
        attrs: {
          tabindex: '-1',
        },
        onClick: () => {
          this.isApplyButtonClicked = true;
          this.wppChange.emit({
            date: this.datePickerInstance.selectedDates,
            formattedDate: this.datePickerInstance.selectedDates.map(selectedDate => this.datePickerInstance.formatDate(selectedDate, this.getDateFormat())),
          });
          if (this.range && Array.isArray(this.lastValidDate)) {
            this.lastAppliedDate = this.lastValidDate;
          }
          this.hasPresets() ? this.handleHideDropdown() : this.datePickerInstance.hide();
        },
      };
      const buttonCancel = {
        content: 'Clear All',
        className: 'disabled button-clear',
        attrs: {
          tabindex: '-1',
        },
        onClick: () => {
          this.clearDatePicker();
        },
      };
      const buttonsConfig = {
        buttons: [buttonCancel, buttonApply],
      };
      const IconChevron = transformToVersionedTag('wpp-icon-chevron');
      this.datePickerInstance = new airDatepicker(this.inputRef, {
        container: this.portalRef,
        range: this.range,
        toggleSelected: this.toggleSelected,
        multipleDatesSeparator: DATES_SEPARATOR,
        autoClose: !this.range,
        inline: this.static || this.hasPresets(),
        locale: { ...defaultLocale, ...this.locale },
        showOtherMonths: false,
        selectOtherMonths: false,
        view: this.getDatepickerView(),
        minView: this.getDatepickerView(),
        dateFormat: this.getDateFormat(),
        navTitles: {
          days: '<p class="datepicker-header">MMMM</p>,<p class="datepicker-header header-year">yyyy</p>',
          years: '<p class="years">yyyy1 - yyyy2</p>',
        },
        nextHtml: `<${IconChevron} class="nav-icon"></${IconChevron}>`,
        prevHtml: `<${IconChevron} class="nav-icon prev-icon"></${IconChevron}>`,
        onShow: (isFinished) => {
          if (isFinished) {
            this.updateDatepickerClearButton(this.lastValidDate);
          }
        },
        onHide: async (isAnimationComplete) => {
          if (isAnimationComplete) {
            if (this.range && !this.isApplyButtonClicked) {
              this.onHideGetLastAppliedValue();
            }
            this.isApplyButtonClicked = false;
            this.handleHideDropdown();
          }
        },
        onRenderCell: ({ date, datepicker }) => {
          if (datepicker.viewDate.getMonth() !== date.getMonth()) {
            return {
              classes: 'outside-current-view',
            };
          }
        },
        onSelect: ({ date, formattedDate }) => {
          const formatDate = getCurrentFormatDate(this.getDateFormat(), this.getDateFormatSeparator(this.getDateFormat()));
          if (!this.range) {
            this.wppChange.emit({
              date,
              formattedDate: formattedDate || '',
            });
          }
          if (!this.range && !Array.isArray(formattedDate)) {
            this.lastValidDate = formattedDate;
            if (formattedDate) {
              this.datePickerInstance.setViewDate(formatDate(formattedDate));
            }
            return;
          }
          if (formattedDate?.length) {
            const [startDate] = formattedDate;
            if (formattedDate.length === 2) {
              this.portalRef?.classList.add('range-selected');
            }
            else {
              this.portalRef?.classList.remove('range-selected');
            }
            if (!this.hasPresets()) {
              this.datePickerInstance.setViewDate(formatDate(startDate));
            }
            this.lastValidDate = formattedDate;
          }
        },
        ...(this.range ? buttonsConfig : {}),
      });
      this.datePickerInstance['$datepicker'].setAttribute('part', 'datepicker');
    };
    this.onHideGetLastAppliedValue = () => {
      if (this.lastAppliedDate.length === 2) {
        if (Array.isArray(this.lastValidDate) && this.lastValidDate.length === 1) {
          this.datePickerInstance.clear();
        }
        const formatDate = getCurrentFormatDate(this.getDateFormat(), this.getDateFormatSeparator(this.getDateFormat()));
        this.lastValidDate = this.lastAppliedDate;
        this.value = this.lastAppliedDate.join(DATES_SEPARATOR);
        this.datePickerInstance.selectDate([formatDate(this.lastAppliedDate[0]), formatDate(this.lastAppliedDate[1])]);
      }
      else {
        this.clearDatePicker();
      }
    };
    this.attachNodeToAnchor = () => {
      if (!this.portalRef)
        return this.host;
      if (this.appendToListWrapper) {
        this.containerRef?.appendChild(this.portalRef);
      }
      else {
        const containerEl = document.querySelector('#root') || document.querySelector('#app') || document.body;
        containerEl.appendChild(this.portalRef);
        this.portalRef.classList.add('from-datepicker');
      }
      return this.portalRef;
    };
    this.showDropdownFloatingUI = () => {
      if (!this.hidden)
        return;
      if (this.portalRef) {
        this.portalRef.style.display = 'flex';
      }
      const floatingEl = this.attachNodeToAnchor();
      this.cleanUpFloatingUI = computeFloatingUI({
        referenceEl: this.inputRef,
        floatingEl,
        configOptions: {
          placement: 'bottom-start',
          zIndex: Z_INDEX.CONTEXT_MENU,
          offset: 4,
          shouldNotFlipEl: this.hasPresets(),
          triggerElementWidth: false,
        },
        showStyles: { display: 'flex', visibility: 'visible' },
      });
      if (this.hasPresets()) {
        this.portalRef?.classList.remove('hide-portal');
        this.portalRef?.classList.add('show-portal');
        this.datePickerInstance.update();
        this.updateDatepickerClearButton(this.lastValidDate);
        setTimeout(() => {
          document.addEventListener('click', this.handleClickOutside);
        }, ANIMATION_DURATION);
      }
      this.hidden = false;
    };
    this.handleClickOutside = (event) => {
      if (event.target && event.target.classList.contains('datepicker-header'))
        return;
      if (event.target && event.target.parentNode) {
        const parentNode = event.target.parentElement;
        if (parentNode && parentNode.classList.contains('air-datepicker-button'))
          return;
      }
      if (this.portalRef && !isEventTargetContained(this.portalRef, event) && this.host !== event.target) {
        this.handleHideDropdown();
      }
    };
    this.handleHideDropdown = () => {
      if (this.hidden)
        return;
      if (this.hasPresets()) {
        this.portalRef?.classList.remove('show-portal');
        this.portalRef?.classList.add('hide-portal');
        document.removeEventListener('click', this.handleClickOutside);
        setTimeout(() => {
          this.hideDropdownFloatingUI();
          this.onHideGetLastAppliedValue();
        }, ANIMATION_DURATION);
      }
      else {
        this.hideDropdownFloatingUI();
      }
    };
    this.hideDropdownFloatingUI = () => {
      if (!this.portalRef || !this.containerRef)
        return;
      this.portalRef.classList.remove('hide-portal');
      this.containerRef.appendChild(this.portalRef);
      this.portalRef.style.visibility = 'hidden';
      setTimeout(() => {
        if (this.portalRef) {
          this.portalRef.style.display = 'none';
        }
      });
      if (this.cleanUpFloatingUI) {
        this.cleanUpFloatingUI();
        this.cleanUpFloatingUI = undefined;
      }
      this.hidden = true;
    };
    this.clearDatePicker = () => {
      if (!this.lastValidDate)
        return;
      this.lastValidDate = '';
      this.lastAppliedDate = [];
      this.datePickerInstance.clear();
      this.datePickerInstance.update();
      this.wppDateClear.emit({
        clear: true,
      });
    };
    this.onInput = () => {
      this.focusType = FOCUS_TYPE.NONE;
    };
    this.onBlur = (event) => {
      this.focusType = FOCUS_TYPE.NONE;
      this.value = event.target.value;
      this.wppBlur.emit(event);
      if (!this.lastValidDate) {
        this.value = this.lastValidDate;
      }
      if (!this.range && !isValidDate(new Date(this.value)) && !Array.isArray(this.lastValidDate)) {
        return (this.value = this.lastValidDate);
      }
      if (Array.isArray(this.lastValidDate)) {
        this.value = this.lastValidDate.join(DATES_SEPARATOR);
      }
    };
    this.onFocus = (event) => {
      this.wppFocus.emit(event);
      if (!this.static) {
        this.showDropdownFloatingUI();
      }
    };
    this.onMouseDown = () => {
      this.focusType = FOCUS_TYPE.MOUSE;
    };
    this.onKeyUp = (event) => {
      if (event.key === 'Tab') {
        this.focusType = FOCUS_TYPE.TAB;
      }
      const isAddedChar = event.key !== 'Backspace';
      const dateFormat = this.getDateFormat();
      const separator = this.getDateFormatSeparator(dateFormat);
      const dateAndSeparator = dateFormat.length + DATES_SEPARATOR.length;
      const toDateObject = getCurrentFormatDate(dateFormat, separator);
      const getDateInfo = (date) => getFormattedDateString(date, dateFormat, separator);
      const dates = this.inputRef.value.split(DATES_SEPARATOR).map(date => date.replace(/[^a-zA-Z0-9]/g, ''));
      let datesInfo = [getDateInfo(dates[0]), getDateInfo(dates[1])];
      const isAllDatesFulfilled = datesInfo.every(info => info.isAllMatchedPartsLength);
      const isOnlyFirstDateFulfilled = datesInfo[0].isAllMatchedPartsLength && !dates[1];
      let cursorPosition = this.inputRef.selectionStart;
      // Sort dates if both fulfilled, including cursor position
      if (isAllDatesFulfilled && toDateObject(datesInfo[0].formattedDate) > toDateObject(datesInfo[1].formattedDate)) {
        datesInfo = datesInfo.reverse();
        cursorPosition = ((cursorPosition > dateAndSeparator && cursorPosition - dateAndSeparator) ||
          (cursorPosition <= dateFormat.length && cursorPosition + dateAndSeparator));
      }
      const inputValue = this.range
        ? datesInfo
          .map(info => info.formattedDate)
          .join(datesInfo[0].isAllMatchedPartsLength || dates[1] ? DATES_SEPARATOR : '')
        : datesInfo[0].formattedDate;
      cursorPosition = getNextCursorPosition(inputValue, cursorPosition, isAddedChar, separator);
      const inputDates = datesInfo
        .filter(info => info.isAllMatchedPartsLength)
        .map(info => toDateObject(info.formattedDate));
      if (!isEqual_1(inputDates, this.datePickerInstance.selectedDates)) {
        // @ts-ignore Due to outdated air-datepicker.d.ts
        this.datePickerInstance.clear({ silent: true });
        // @ts-ignore Due to outdated air-datepicker.d.ts
        this.datePickerInstance.selectDate(inputDates).then(() => {
          if (!(isOnlyFirstDateFulfilled || isAllDatesFulfilled)) {
            this.updateInput(inputValue, cursorPosition);
          }
          if (this.range && isOnlyFirstDateFulfilled) {
            this.updateInput(this.inputRef.value + DATES_SEPARATOR, cursorPosition === dateFormat.length ? cursorPosition + DATES_SEPARATOR.length : cursorPosition);
          }
        });
      }
      this.updateInput(inputValue, cursorPosition);
    };
    this.updateInput = (value, cursorPosition) => {
      if (this.inputRef) {
        this.inputRef.value = value;
        this.value = value;
        this.inputRef.setSelectionRange(cursorPosition, cursorPosition);
      }
    };
    this.onKeyDown = (event) => {
      const allowedKeys = [
        'Backspace',
        'Delete',
        'Tab',
        'Escape',
        'Enter',
        '/',
        '|',
        ...Array.from({ length: 10 }, (_, i) => i.toString()),
      ];
      if (!allowedKeys.includes(event.key) && !event.metaKey && !event.ctrlKey) {
        event.preventDefault();
      }
    };
    this.handleBlurPortal = (event) => {
      if (event.relatedTarget && this.portalRef && this.portalRef.contains(event.relatedTarget))
        return;
      this.hideTimer = setTimeout(() => this.handleHideDropdown());
    };
    this.handlePreviewPreset = (dateRange) => {
      if (this.previewPresetTimer) {
        clearTimeout(this.previewPresetTimer);
      }
      const formatDate = getCurrentFormatDate(this.getDateFormat(), this.getDateFormatSeparator(this.getDateFormat()));
      const [currentSelectedStartDate, currentSelectedEndDate] = this.datePickerInstance.selectedDates;
      const formattedStartDate = formatDate(dateRange[0]);
      const formattedEndDate = formatDate(dateRange[1]);
      if (isValidDate([formattedStartDate, formattedEndDate]) &&
        (!isEqual_1(currentSelectedStartDate, formattedStartDate) || !isEqual_1(currentSelectedEndDate, formattedEndDate))) {
        this.datePickerInstance.selectDate([formattedStartDate, formattedEndDate]);
        this.datePickerInstance.setViewDate(formattedStartDate);
        this.datePickerInstance.update();
      }
    };
    this.handleClickPreset = (preset) => {
      clearTimeout(this.hideTimer);
      this.hasClickedPreset = true;
      this.value = preset.value;
      this.lastValidDate = preset.value;
      this.lastAppliedDate = preset.value;
      this.wppChange.emit({
        date: this.datePickerInstance.selectedDates,
        formattedDate: this.datePickerInstance.selectedDates.map(selectedDate => this.datePickerInstance.formatDate(selectedDate, this.getDateFormat())),
      });
      this.handleHideDropdown();
    };
    this.handleMouseLeavePreset = () => {
      if (this.hasClickedPreset) {
        this.hasClickedPreset = false;
        return;
      }
      this.previewPresetTimer = setTimeout(() => {
        if (this.lastAppliedDate.length > 0) {
          this.handlePreviewPreset(this.lastAppliedDate);
        }
        else {
          this.datePickerInstance.clear();
          this.datePickerInstance.setViewDate(new Date());
          this.lastValidDate = '';
        }
      }, 100);
    };
    this.hostCssClasses = () => ({
      'wpp-datepicker': true,
      disabled: this.disabled,
      [`size-${this.size}`]: true,
    });
    this.inputCssClasses = () => ({
      'datepicker-input': true,
      [`${this.messageType}`]: !!this.messageType,
      [`size-${this.size}`]: true,
      [this.focusType]: true,
    });
    this.iconCrossCssClasses = () => ({
      'cross-icon': true,
      disabled: this.disabled,
      [`size-${this.size}`]: true,
    });
    this.iconCalendarCssClasses = () => ({
      'calendar-icon': true,
      [`size-${this.size}`]: true,
    });
    this.containerClasses = () => ({
      'single-datepicker': !this.range,
      'range-datepicker': this.range,
      'has-default-format': this.isDefaultDateFormat(),
      'static-datepicker': this.static,
      'with-presets': this.hasPresets(),
    });
    this.portalClasses = () => ({
      'wpp-portal': true,
      'static-portal': this.static,
      'with-presets': this.hasPresets(),
    });
    this.datePickerInstance = undefined;
    this.lastValidDate = undefined;
    this.lastAppliedDate = [];
    this.focusType = undefined;
    this.hidden = true;
    this.range = false;
    this.toggleSelected = false;
    this.value = undefined;
    this.autoFocus = false;
    this.static = false;
    this.minDate = undefined;
    this.maxDate = undefined;
    this.placeholder = undefined;
    this.view = 'days';
    this.message = undefined;
    this.messageType = undefined;
    this.tooltipConfig = {};
    this.maxMessageLength = undefined;
    this.required = false;
    this.disabled = false;
    this.name = undefined;
    this.size = 'm';
    this.presets = [];
    this.labelTooltipConfig = {
      popperOptions: { strategy: 'fixed' },
    };
    this.locale = {
      days: DAYS,
      daysShort: DAYS_SHORT,
      daysMin: DAYS_MIN,
      months: MONTHS,
      monthsShort: MONTHS_SHORT,
      today: 'Today',
      clear: 'Clear',
      dateFormat: DATE_FORMAT.DAY_MONTH_YEAR,
      timeFormat: 'hh:mm aa',
      firstDay: 0,
    };
    this.labelConfig = undefined;
    this.appendToListWrapper = false;
  }
  /**
   * Method that returns a datepicker instance which allows manipulating all props and changing them as necessary. [Read more](https://air-datepicker.com/docs).
   */
  async getInstance() {
    return this.datePickerInstance;
  }
  /**
   * Method that sets focus on the input.
   */
  async setFocus() {
    this.inputRef?.focus();
  }
  async updateDatepickerClearButton(newValidDate) {
    const clearButton = this.portalRef?.querySelector('.air-datepicker--buttons .button-clear');
    const applyButton = this.portalRef?.querySelector('.air-datepicker--buttons .button-apply');
    if (newValidDate) {
      clearButton?.classList?.remove('disabled');
    }
    else {
      clearButton?.classList?.add('disabled');
    }
    if (Array.isArray(newValidDate) && newValidDate.length === 2) {
      applyButton?.classList?.remove('disabled');
    }
    else {
      applyButton?.classList?.add('disabled');
    }
  }
  updateValue() {
    if (this.value === '' || isEqual_1(this.value, [])) {
      this.clearDatePicker();
      return;
    }
    if (!this.value)
      return;
    if (this.range) {
      this.setInitialDate();
    }
    else {
      if (!this.isStringDateValid(this.value))
        return;
      const formatDate = getCurrentFormatDate(this.getDateFormat(), this.getDateFormatSeparator(this.getDateFormat()));
      const formattedDate = formatDate(this.value);
      const currentDatePickerValue = this.datePickerInstance.selectedDates[0];
      if (isValidDate(formattedDate) && !isEqual_1(formattedDate, currentDatePickerValue)) {
        this.setInitialDate();
      }
    }
  }
  updateRange() {
    this.clearDatePicker();
    this.datePickerInstance.destroy();
    this.createDateInstance();
  }
  updateMinDate() {
    this.setMinMaxDate();
  }
  updateMaxDate() {
    this.setMinMaxDate();
  }
  componentWillLoad() {
    if (!this.isDefaultDateFormat()) {
      if (this.range) {
        console.warn(`Warning: When using the range datepicker, only default date formats can be applied. For example, ` +
          `MM/dd/yyyy, dd/MM/yyyy, and other variations using only MM, dd, yyyy with '/' or '.' separators. ` +
          `Default format ${DATE_FORMAT.DAY_MONTH_YEAR} will be used instead.`);
      }
      else {
        console.warn(`Warning: When using the datepicker with a different format than the default one, the input becomes read-only. Our default formats are: MM/dd/yyyy, dd/MM/yyyy, and other variations using only MM, dd, yyyy with '/' or '.' separators.`);
      }
    }
  }
  componentDidLoad() {
    this.createDateInstance();
    this.setInitialDate();
    this.setMinMaxDate();
    autoFocusElement(this.autoFocus, this.inputRef);
    if ((this.portalRef && this.static) || this.hasPresets()) {
      const datepickerEl = this.host.shadowRoot?.querySelector('[part="datepicker"]');
      if (datepickerEl) {
        this.portalRef?.appendChild(datepickerEl);
      }
    }
  }
  render() {
    return (h(Host, { class: this.hostCssClasses(), exportparts: "label, datepicker-container, icon-calendar, datepicker-input, icon-cross, message" }, this.labelConfig?.text && (h("wpp-label-v2-13-3", { class: "label", htmlFor: this.name, optional: !this.required, config: this.labelConfig, tooltipConfig: this.labelTooltipConfig, part: "label" })), h("div", { class: this.containerClasses(), ref: ref => (this.containerRef = ref), id: "container", part: "datepicker-container" }, h("wpp-icon-calendar-v2-13-3", { class: this.iconCalendarCssClasses(), part: "icon-calendar" }), h("input", { id: "datepicker", type: "text", class: this.inputCssClasses(), onInput: this.onInput, onBlur: this.onBlur, onFocus: this.onFocus, onMouseDown: this.onMouseDown, onKeyUp: this.onKeyUp, onKeyDown: this.onKeyDown, disabled: this.disabled, readOnly: !this.range && !this.isDefaultDateFormat(), placeholder: this.placeholder ||
        (this.range
          ? `${this.locale.dateFormat}${DATES_SEPARATOR}${this.locale.dateFormat}`
          : `${this.locale.dateFormat}`), ref: inputRef => (this.inputRef = inputRef), autocomplete: "off", part: "datepicker-input", title: "" }), h("div", { onBlur: this.handleBlurPortal, onFocus: () => clearTimeout(this.hideTimer), ...(this.hasPresets() ? { tabIndex: 0 } : {}), ref: ref => (this.portalRef = ref), class: this.portalClasses() }, this.hasPresets() && (h("div", { class: "presets-container" }, h("div", { class: "presets-list" }, this.presets.map((preset) => (h("wpp-list-item-v2-13-3", { onMouseEnter: () => this.handlePreviewPreset(preset.value), onMouseLeave: this.handleMouseLeavePreset, onWppChangeListItem: () => this.handleClickPreset(preset), class: "presets-item" }, h("wpp-typography-v2-13-3", { type: "s-body", slot: "label" }, preset.label))))), h("div", { class: "presets-footer" })))), !!this.lastValidDate && (h("wpp-icon-cross-v2-13-3", { class: this.iconCrossCssClasses(), "aria-label": "Erase date", onClick: this.clearDatePicker, part: "icon-cross" })), this.message && (h("wpp-inline-message-v2-13-3", { class: "inline-message", message: this.message, type: this.messageType, showTooltipFrom: this.maxMessageLength, tooltipConfig: this.tooltipConfig, part: "message" })))));
  }
  static get registryIs() { return "wpp-datepicker-v2-13-3"; }
  get host() { return this; }
  static get watchers() { return {
    "lastValidDate": ["updateDatepickerClearButton"],
    "value": ["updateValue"],
    "range": ["updateRange"],
    "minDate": ["updateMinDate"],
    "maxDate": ["updateMaxDate"]
  }; }
  static get style() { return wppDatepickerCss; }
}, [1, "wpp-datepicker", "wpp-datepicker-v2-13-3", {
    "range": [4],
    "toggleSelected": [4, "toggle-selected"],
    "value": [1025],
    "autoFocus": [4, "auto-focus"],
    "static": [4],
    "minDate": [1, "min-date"],
    "maxDate": [1, "max-date"],
    "placeholder": [1],
    "view": [1],
    "message": [1],
    "messageType": [1, "message-type"],
    "tooltipConfig": [1040],
    "maxMessageLength": [2, "max-message-length"],
    "required": [516],
    "disabled": [516],
    "name": [1],
    "size": [1],
    "presets": [16],
    "labelTooltipConfig": [16],
    "locale": [16],
    "labelConfig": [1040],
    "appendToListWrapper": [1028, "append-to-list-wrapper"],
    "datePickerInstance": [32],
    "lastValidDate": [32],
    "lastAppliedDate": [32],
    "focusType": [32],
    "hidden": [32],
    "getInstance": [64],
    "setFocus": [64]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-datepicker-v2-13-3", "wpp-action-button-v2-13-3", "wpp-checkbox-v2-13-3", "wpp-icon-calendar-v2-13-3", "wpp-icon-chevron-v2-13-3", "wpp-icon-cross-v2-13-3", "wpp-icon-dash-v2-13-3", "wpp-icon-error-v2-13-3", "wpp-icon-info-v2-13-3", "wpp-icon-success-v2-13-3", "wpp-icon-tick-v2-13-3", "wpp-icon-warning-v2-13-3", "wpp-inline-message-v2-13-3", "wpp-internal-label-v2-13-3", "wpp-internal-tooltip-v2-13-3", "wpp-label-v2-13-3", "wpp-list-item-v2-13-3", "wpp-spinner-v2-13-3", "wpp-tooltip-v2-13-3", "wpp-typography-v2-13-3"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-datepicker-v2-13-3":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppDatepicker$1);
      }
      break;
    case "wpp-action-button-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$k();
      }
      break;
    case "wpp-checkbox-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$j();
      }
      break;
    case "wpp-icon-calendar-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$i();
      }
      break;
    case "wpp-icon-chevron-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$h();
      }
      break;
    case "wpp-icon-cross-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$g();
      }
      break;
    case "wpp-icon-dash-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$f();
      }
      break;
    case "wpp-icon-error-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$e();
      }
      break;
    case "wpp-icon-info-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$d();
      }
      break;
    case "wpp-icon-success-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$c();
      }
      break;
    case "wpp-icon-tick-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$b();
      }
      break;
    case "wpp-icon-warning-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$a();
      }
      break;
    case "wpp-inline-message-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$9();
      }
      break;
    case "wpp-internal-label-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$8();
      }
      break;
    case "wpp-internal-tooltip-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$7();
      }
      break;
    case "wpp-label-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$6();
      }
      break;
    case "wpp-list-item-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$5();
      }
      break;
    case "wpp-spinner-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "wpp-tooltip-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "wpp-typography-v2-13-3":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}
defineCustomElement$1();

const WppDatepicker = WppDatepicker$1;
const defineCustomElement = defineCustomElement$1;

export { WppDatepicker, defineCustomElement };
